{
  "A11Y": {
    "TRANSLATABLE_FORM_TAB_ARIA_LABEL": "Amanqaku okhetho lolwimi lwefom."
  },
  "ACCESS_CONTROL": {
    "WITHOUT_RIGHT_PERMISSIONS": "Uxolo, awunamvume eyaneleyo yokufikelela kule phepha."
  },
  "ADD_TO_CALENDAR": {
    "TITLE": "Ikhalenda",
    "URL_WITH_EVENT": "{description} \n Joyina intlanganiso yevidiyo: {url}"
  },
  "ANONYMOUS": "Engaziwayo",
  "API_SAUCE": {
    "CANCEL_ERROR": "Isicelo senkonzo sinqunyulwe.",
    "CLIENT_ERROR": "Owu, impazamo engalindelekanga yenzekile.",
    "CONNECTION_ERROR": "Umncedisi akafumaneki.",
    "NETWORK_ERROR": "Imposiso yenethiwekhi, khangela uqhagamshelo lwakho.",
    "SERVER_ERROR": "Uxolo, kwenzeke impazamo engalindelekanga.",
    "TIMEOUT_ERROR": "Umncedisi akaphendulanga ngexesha."
  },
  "ARTICLE": {
    "NOT_PUBLISHED": "Akhangephawuliwe",
    "PUBLICATION_ALERT": "Icwangcisiwe ngo-{date} ngexesha lika-{time}."
  },
  "ASSIGNMENT_CARD": {
    "AVATAR_ALT": "Ifoto yomphathi",
    "TITLE": "Unoxanduva"
  },
  "ASSIGNMENT_MODAL": {
    "CHOOSE_ADMIN": "Khetha umlawuli",
    "TITLE": "Ukugqithisela unyango lwale galelo"
  },
  "ATTACHMENTS": {
    "ERROR": {
      "DELETE_FAILED": "Asikho kwazanga ukususa le fayile eqhotyoshelweyo.",
      "TITLE": "Imposiso -"
    }
  },
  "ATTENDANCE": {
    "ATTEND": "Ndiyathatha inxaxheba",
    "ATTENDING": "Ubhalisile"
  },
  "AUTH": {
    "ACCEPT_SPACE_PRIVACY": "Ndiyavuma <terms>ummiselo wabucala</terms> ka-{spaceName}.",
    "ACCEPT_SPACE_TERMS": "Ndiyavuma <privacy>iimeko zokusebenzisa</privacy> ze-{spaceName}.",
    "ACCEPT_SPACE_TERMS_AND_PRIVACY": "Ndiyavuma <privacy>umgaqo-nkqubo wabucala</privacy> kunye <terms>nemigaqo yokusetyenziswa</terms> ye-{spaceName}.",
    "ACCEPT_TERMS_AND_PRIVACY": "Ndiyavuma {privacy} kunye ne {terms} ze Fluicity Engage.",
    "ARIA_AUTHENTICATE_WITH": "Bhalisa kunye no-{provider}",
    "AUTH_LIST_TITLE": "Iinkonzo zokuqinisekisa zomntu wesithathu",
    "BACKGROUND_ALT": "Umzobo wasemva",
    "CONTINUE_WITHOUT_SIGNUP": "Qhubeka ngaphandle kweakhawunti",
    "DELETE_TOAST": "Inkonzo yesiqinisekiso sesithathu ikhutshiwe ngempumelelo",
    "DESCRIPTION": "Ukubhaliswa kwakho ku-Fluicity Engage kuzakuvumela ukuba uthathe inxaxheba kwiingxoxo kwi-{spaceName} kwaye kuzakunika ukufikelela kwezinye iingxoxo ezilungiselelwe kwi-Fluicity Engage. Ukufunda ngakumbi ngolawulo lwedatha yakho kunye nokusebenzisa amalungelo akho, nceda ujonge kwi <b>Umgaqo-nkqubo Wobumfihlo.</b>",
    "EMAIL_PLACEHOLDER": "exemple@email.com",
    "ENTITY_SUBSCRIPTION_FORM": {
      "CONTENT": "Ngokujoyina <strong>{spaceName}</strong>, uzakuhlala unolwazi malunga neengcebiso zakutshanje kunye neendaba.<br></br><br></br>Unako kananjalo ukunceda ekuqondeni ngcono ukuba ngaba lo msebenzi umele uluntu ngokubanzi ngokwabelana ngolwazi oluthile:",
      "TITLE": "Joyina {spaceName}!"
    },
    "ERRORS": {
      "CANNOT_DELETE_WITHOUT_PASSWORD": "Cwangcisa iphasiwedi ukuze ususe le nkonzo yokuqinisekiswa komntu wesithathu.",
      "DELETE_AUTH_FAILED": "Asikwazanga ukususa le nkonzo yokungena ngemvume yenkampani yangaphandle.",
      "INVALID_EMAIL": "Ifomathi yedilesi ye-imeyile yakho ayichanekanga.",
      "NO_ASSOCIATED_ACCOUNT": "Akukho akhawunti edityaniswe.",
      "REQUIRED_CHECKBOX": "Kufuneka uyijonge le bhokisi.",
      "REQUIRED_EMAIL": "Kufuneka unikeze idilesi ye-imeyile.",
      "REQUIRED_FIRST_NAME": "Kufuneka unike igama lokuqala.",
      "REQUIRED_LAST_NAME": "Kufuneka unike igama.",
      "REQUIRED_PASSWORD": "Kufuneka unikeze igama lokugqitha.",
      "SHORT_PASSWORD": "Ipaswedi kufuneka ibe nobude obuncinane obuyi-{count}."
    },
    "FACEBOOK_LOAD_ERROR": "Kubukeka ngathi isandiso esikhutshiweyo kwisikhangeli sakho siyasithintela ekusebenziseni iFacebook yokungqinisisa. Nceda ucime isandiso ukuba ufuna ukusebenzisa lo msebenzi.",
    "FIRST_NAME_PLACEHOLDER": "Umzekelo: UJean",
    "FORGOT_PASSWORD": "Ithini iphasiwedi yakho?",
    "HAS_ACCOUNT": "Sele akunini?",
    "HAS_SIGNED_IN": "Uxhunyelwe ku-{spaceName}!",
    "LAST_NAME_PLACEHOLDER": "Umzekelo: Dupont",
    "LOGIN": "Ngena kwi-akhawunti",
    "NAME_PREVIEW": "Abanye abasebenzisi baza kukubona njenge:",
    "NO_ACCOUNT": "Awukabikho akhawunti?",
    "OAUTH_BUTTONS": {
      "CSAM": "Ujoyine nge-CSAM"
    },
    "PAGE_TITLE": "Ngena kwi-akhawunti yakho",
    "SIGNUP": "Yenza i-akhawunti",
    "SIGNUP_EXTRAS": {
      "DESCRIPTION": "Sicela usincede siqonda ngcono ukuba ingaba umsebenzi weqonga umela uluntu luphela. Olu lwazi luza kusetyenziswa kuphela kwiinjongo zokujonga ukuba abathathi-nxaxheba basemthethweni na kunye neenkcukacha-manani ezinxulumene nokuthatha inxaxheba.",
      "PAGE_TITLE": "Inyathelo lokugqibela!",
      "WELCOME_TOAST": "Usenelisa, ujoyine {spaceName} !"
    },
    "UNLINK": "Ukuphuma",
    "VERIFY_EMAIL": {
      "CONTENT": "Faka ikhowudi yokuqinisekisa oyifumene kwi-imeyile {email}.",
      "RESEND": "Awuyifumananga i-imeyile? {link}",
      "RESEND_LINK": "Renvoyer le code",
      "RESEND_SUCCESS": "Ikhowudi entsha yokuqinisekisa ithunyelwe kuwe.",
      "TITLE": "Qinisekisa i-akhawunti yakho",
      "VERIFY_ALERT": "Khangela idilesi ye-imeyile yakho ukuze uthathe inxaxheba kuzo zonke iingxoxo.",
      "VERIFY_SUCCESS": "I-akhawunti yakho iqinisekisiwe ngempumelelo."
    }
  },
  "BACK": "Ngaphambili",
  "BUTTONS": {
    "ACCEPT": "Yamkela",
    "ACCESS_CONSULTATION": "Ukufikelela kwisigqibo",
    "ACTIONS": "Izenzo",
    "ADD": "Yongeza",
    "ADD_ATTACHMENTS": "Yongeza iifayile/imifanekiso",
    "ADD_NEW_IDEA": "Igalelo",
    "CANCEL": "Rhoxisa",
    "CHANGE_USER": "Guqula Umsebenzisi",
    "CLEAR": "Cima",
    "CLONE": "Kopa",
    "CLOSE": "Vala",
    "COMMENT": "Ukuphawula",
    "CONFIRM": "Qinisekisa",
    "CONTINUE": "Qhubeka",
    "DELETE": "Cima kwakhona",
    "DELETE_VOTERS": "Cima abavoti",
    "DRAG_DROP_ATTACHMENTS": "Tsala-ukudonsela iifayile/imifanekiso apha okanye ucofe",
    "EXPORT": "Thumela ngaphandle",
    "EXPORT_PARTICIPANTS": "Thumela abathathi-nxaxheba",
    "EXPORT_PROPOSALS": "Thumela izipho",
    "EXPORT_RESULTS": "Thumela iziphumo",
    "EXPORT_VOTERS": "Thumela abavoti",
    "FILTER": "Hluza",
    "IGNORE": "Hayi ngoku",
    "IMPORT": "Ngenisa",
    "IMPORT_VIA_EXCEL": "Ngenisa ifayile ye-Excel",
    "IMPORT_VIA_FORM": "Gcwalisa ifom yesicelo kwi-intanethi",
    "IMPORT_VOTERS": "Ngenisa abavoti",
    "IN_PROGRESS": "Kuqhuba…",
    "JOIN": "Joyina",
    "LEARN_MORE": "Funda kabanzi",
    "NO": "Hayi",
    "OPEN": "Vula",
    "OPEN_IN_NEW_TAB": "Vula ithebhu entsha",
    "PUBLISH": "Shicilela",
    "READ_MORE": "Bona ngakumbi",
    "REJECT_ALL": "Lahla konke",
    "SAVE": "Enkulumkisa",
    "SETTINGS": "Izicwangciso",
    "SKIP": "Ukupasa",
    "TRANSLATE_VIA_AI": "Guqula nge-AI",
    "UPDATE": "Lungisa",
    "UPDATE_PICTURE": "Umhleli",
    "UPLOAD_PICTURE": "Yongeza ifoto",
    "VERIFY": "Qinisekisa",
    "VERIFY_EMAIL": "Qinisekisa idilesi yam ye-imeyile",
    "VIEW_ANSWER": "Jonga impendulo",
    "VIEW_IDEAS": "Jonga izibonelelo",
    "VOTE": {
      "BUDGET": "Ndiwuxhasa",
      "NOT_SUPPORT": "Andiyixhasi",
      "SUPPORT": "Ndiyaxhasa",
      "TOAST": {
        "CANCEL": "Ivoti lakho lisusiwe ngempumelelo",
        "SUCCESS": "Ivoti yakho ibhaliswe ngempumelelo."
      },
      "VOTE_AGAINST": "Ndivota ngokuchasene.",
      "VOTE_FOR": "Ndivota ngenxa ka"
    },
    "WRITE": "Bhala"
  },
  "CHILDREN_COUNT": "{count, plural, =0 {Akukho ziqulatho} one {{count} isiqulatho} other {{count} iziqulatho}}",
  "COMMENTS": {
    "AUTHOR": "Umbhali",
    "CREATE": {
      "PRIVACY_WARNING": "Lo mxholo yimfihlo. Kuphela umbhali kunye nombutho obhalelwe ungawubona.",
      "SUBMIT": "Thumela"
    },
    "CREATION": {
      "APPEND_COMMENT": {
        "IDEA": "Shiya amazwana esidlangalaleni ukuchaza utshintsho kwimeko."
      },
      "ERROR": "Kufuneka ugcwalise ngokufanelekileyo iindawo.",
      "PLACEHOLDER": "Umbono wakho",
      "SUCCESS_ANOMALY": "Impendulo yakho ithunyelwe.",
      "SUCCESS_DEMAND": "Impendulo yakho ithunyelwe.",
      "SUCCESS_IDEA": "Umbono wakho upapashwe.",
      "VALIDATE": "Qinisekisa"
    },
    "SHOW": {
      "BE_THE_FIRST_TO_COMMENT_CONSULTATION": "Yiba ngowokuqala ukuphawula!",
      "BE_THE_FIRST_TO_COMMENT_MESSAGING": "Lo mntu ulindele impendulo yakho ukususela nge-{date}.",
      "BE_THE_FIRST_TO_COMMENT_PARTICIPATION": "Yiba ngowokuqala ukuphawula!",
      "CONTRIBUTION_ENDED": "Ukubonisana kugqityiwe",
      "CONTRIBUTION_ENDED_ON": "Ukubonisana kuphelile ngu-{date}",
      "CONTRIBUTION_HAS_NOT_STARTED": "Uthethwano luqala nge-{date}",
      "COUNT_CONSULTATION": "{count, plural, =0 {Akukho ngxelo} one {{count} Ingxelo} other {{count} Iingxelo}}",
      "COUNT_MESSAGING": "{count, plural, =0 {Akukho mpendulo} one {{count} Impendulo} other {{count} Iimpendulo}}",
      "COUNT_PARTICIPATION": "{count, plural, =0 {Akukho ngxelo} one {{count} Ingxelo} other {{count} Iingxelo}}"
    },
    "THREAD": {
      "DELETED_COMMENT": "Esi siphawuli sikhutshiwile.",
      "DISPLAY_CONVERSATION": "{count, plural, =0 {Akukho mpendulo} one {Jonga {count} mpendulo} other {Jonga {count} iimpendulo}}",
      "REPLY": "Phendula"
    },
    "TITLE": "Iintetho"
  },
  "CONTRAST_RATIO": {
    "DESCRIPTION": "Ukuchasana okwaneleyo kuvumela umgangatho wokufikeleleka owamkelekileyo kubasebenzisi bakho. Ngokuhambelana nezindululo zamazwe ngamazwe (WCAG) kunye nezikaReferensi jikelele zokuphucula ukufikeleleka (RGAA) sicebisa ukuba ukhethe umbala onokuchasana okungenani {ratio}:1 (ohambelana nenqanaba AA lomgangatho weWCAG version 2.1)",
    "TEXT": {
      "BAD": "Ubuso bokuchasana balombala bungango- {value}:1, abuveleli emigaqweni yokufikeleleka (WCAG inqanaba AA)",
      "GOOD": "Inqanaba lokuchasana kulo mbala ngu-{value}:1 kwaye lihambelana nezikhokelo zokufikelelela (WCAG inqanaba AA)"
    }
  },
  "COOKIES_SETTINGS": {
    "SSO_AUTH_MODAL": {
      "CONTENT": "{providerName} izofaka ii-cookies kwikhompyuter yakho ukuba usebenzisa lo msebenzi."
    },
    "VIDEO_PLACEHOLDER": {
      "ADS_BLOCK": "Uyenze isenzo sokuvimba izikhangiso esivimba ukuboniswa kwevidiyo le. Sicela usivule ukuze uqhubeke.",
      "CTA": "Yamkela iikuki",
      "VIMEO": "U-Vimeo ufuna ukubeka iicookies ukuze abonise ividiyo",
      "YOUTUBE": "I-YouTube ifuna ukubeka iicookies ukuze ibonise ividiyo."
    }
  },
  "DASHBOARD": {
    "BUTTONS": {
      "EXPORT": {
        "CONSULTATION": "Thumela iingcombolo",
        "MESSAGING": "Thumela ngaphandle",
        "PARTICIPATION": "Thumela ngaphandle"
      }
    },
    "COUNTERS": {
      "ASSIGNMENT": "{count, plural, =0 {Akukho misebenzi} one {{count} Umsebenzi} other {{count} Imisebenzi}}",
      "COMMUNICATION": "{count, plural, =0 {Akukho ndaba} one {{count} Indaba} other {{count} Iindaba}}",
      "CONSULTATION": "{count, plural, =0 {Akukho ngcebiso} one {{count} Ingcebiso} other {{count} Iingcebiso}}",
      "FOLDER": "{count, plural, =0 {Akukho fayile} one {{count} Ifayile} other {{count} Iifayile}}",
      "FOLDER_CONTENT": "{count, plural, =0 {Akukho mkhombandlela} one {{count} Mkhombandlela} other {{count} Mikhombandlela}}",
      "FORM_RESPONSES": "{count, plural, =0 {Akukho mpendulo} one {{count} Mpendulo} other {{count} Iimpendulo}}",
      "INVITATIONS": "{count, plural, =0 {Akukho simemo} one {{count} isimemo} other {{count} izimemo}}",
      "MESSAGING": "{count, plural, =0 {Akukho ziqulatho} one {{count} Isiqulatho} other {{count} Iziqulatho}}",
      "NEWSLETTERS": "{count, plural, =0 {Akukho newsletter} one {{count} newsletter} other {{count} newsletters}}",
      "PARTICIPATION": "{count, plural, =0 {Akukho galelo} one {{count} Igalelo} other {{count} Amagalelo}}",
      "RANKING": "Ukuhlelwa kweminikelo",
      "USER": "{count, plural, =0 {Akukho msebenzisi} one {{count} Msebenzisi} other {{count} Basebenzisi}}",
      "VOTERS": "{count, plural, =0 {Akukho voti} one {{count} Voti} other {{count} Voti}}"
    },
    "COUNTERS_SELECTED": {
      "COMMUNICATION": "{count, plural, =0 {Akukho ndaba zikhethiweyo} one {{count} Ndaba ekhethiweyo} other {{count} Iindaba ezikhethiweyo}}",
      "CONSULTATION": "{count, plural, =0 {Akukho ngxoxo ekhethiweyo} one {{count} Ingxoxo ekhethiweyo} other {{count} Iingxoxo ezikhethiweyo}}",
      "FOLDER": "{count, plural, =0 {Akukho fayili ekhethiweyo} one {{count} Ifayili ikhethiweyo} other {{count} Izifayili ezikhethiweyo}}",
      "FOLDER_CONTENT": "{count, plural, =0 {Akukho mqulu ukhethiwe} one {{count} Mqulu ukhethiwe} other {{count} Imiqulu ekhethiwe}}",
      "MESSAGING": "{count, plural, =0 {Akunakho umxholo okhethiwe} one {{count} Umxholo okhethiwe} other {{count} Imixholo ekhethiwe}}",
      "PARTICIPATION": "{count, plural, =0 {Akukho galelo elikhethiweyo} one {{count} Igqiza elikhethiweyo} other {{count} Igalelo elikhethiweyo}}",
      "VOTERS": "{count, plural, =0 {Akukho mntu uvotileyo ukhethiwe} one {{count} Mntu uvotileyo ukhethiwe} other {{count} Bantu abavotileyo abakhethiweyo}}"
    },
    "EDIT": "Ukulungisa",
    "EMPTY_STATE": {
      "ASSIGNMENT": "Apha apha uzakufumana umxholo obelwe kuwe.",
      "COMMUNICATION": "Shicilela iindaba zakho zokuqala",
      "CONSULTATION": "Shicilela ukubonisana kwakho kokuqala",
      "FOLDER": "Yenza ifolda yakho yokuqala",
      "FOLDER_CONTENT": "Uza kufumana apha umxholo wefayile.",
      "FORM_RESPONSES": "Nazi apha impendulo zemibuzo kule ndawo.",
      "INVITATIONS": "Uzakufumana apha uluhlu lwezimemo.",
      "MESSAGING": "Uza kufumana imiyalezo kunye neziphene apha",
      "NEWSLETTER": "Yenza incwadi yakho yokuqala yeendaba",
      "PARTICIPATION": "Nazi apha iikhontribyushini zengxoxo apha.",
      "SEARCH": {
        "BUTTON": "Cwangcisa izihluzi",
        "DESCRIPTION": "Qinisekisa ukuba upelile kakuhle uphando lwakho okanye uguqule iifilitha.",
        "TITLE": "Akukho ziphumo"
      },
      "USER": "Uzaku kufumana apha uluhlu lwabasebenzisi ababhalisileyo.",
      "VOTERS": "Nantsi indawo apho ungafumana khona abantu abavotayo kwiingxoxo."
    },
    "FILTERS": {
      "ADDRESS_CITY": {
        "LABEL": "Commune",
        "PLACEHOLDER": "Hluza ngesixeko"
      },
      "BLANK": "Ayikho idata",
      "FOLDER": {
        "LABEL": "Isethu",
        "PLACEHOLDER": "Hluza ngefayile"
      },
      "NEWSLETTER_STATUS": {
        "DRAFT": "Brouillon",
        "SCHEDULED": "Iphakanyisiwe",
        "SENT": "Ethunyelwe"
      },
      "PROF_CATEGORY": {
        "LABEL": "Ikhathalogu yokusebenza kwezentlalo-profeshinali",
        "PLACEHOLDER": "Khetha ngohlobo lwesigaba sokusebenza kwezentlalo"
      },
      "REGISTERED": {
        "LABEL": "Bhalisiwe",
        "PLACEHOLDER": "Hluza ngekubhaliswa",
        "REGISTERED": "Bhalisiwe",
        "UNREGISTERED": "Engangeniwe"
      },
      "ROLES": {
        "ADMINISTRATOR": "Administratha",
        "AUTHOR": "Umbhali",
        "CITIZEN": "Umsebenzisi",
        "CONTRIBUTOR": "Umphathi",
        "LABEL": "Indima",
        "PLACEHOLDER": "Hluza ngendima"
      },
      "SEX": {
        "LABEL": "Isini",
        "PLACEHOLDER": "Hluza ngohlobo lwezesondo"
      },
      "STATUS": {
        "ANSWERED": "Ayigcinwanga",
        "DOING": "Uhlalutyo luyenzeka",
        "DONE": "Izaliswe ngempumelelo",
        "DUPLICATE": "Ihlanganisiwe",
        "IN_PROGRESS": "Uxanduva luqhuba",
        "LABEL": "Isimo",
        "MESSAGING": {
          "DOING": "Ukuhlalutya kuqhubeka",
          "DONE": "Impendulo inikiwe",
          "LABEL": "Isimo",
          "PLACEHOLDER": "Hluza ngokweemeko",
          "TODO": "Idipozithiwe"
        },
        "PLACEHOLDER": "Coca ngokweemeko",
        "PLANNED": "I planisiweyo",
        "REJECTED": "Yalilekile",
        "SELECTED": "Retenue",
        "TODO": "Idiphozithiwe",
        "TO_MODERATE": "Ukuba qwalaselwa ngenyameko",
        "VALIDATED": "Ophumelele"
      },
      "TAG": {
        "LABEL": "Umxholo",
        "PLACEHOLDER": "Hluza ngeziqhamo"
      },
      "TYPES": {
        "ANOMALY": "Ukuphambuka",
        "ARTICLE": "Inqaku",
        "COLLABORATIVE_DECISION": "Ukubonisana",
        "DEMAND": "Umyalezo",
        "EVENT": "Isiganeko",
        "FOLDER": "Idokhumenti",
        "IDEA": "Igalelo",
        "IDEAS_REQUEST": "Ukubizelwa kwezindima",
        "LABEL": "Uhlobo lomxholo",
        "PARTICIPATORY_BUDGET": "Uhlahlo lwabiwo-mali olubandakanyayo",
        "PLACEHOLDER": "Hluza ngohlobo",
        "STUDY": "Isondlo",
        "SURVEY": "Iphepha lemibuzo"
      },
      "USER_TYPE": {
        "DESCRIPTION": "Ku-intanethi okanye ku-offline",
        "LABEL": "Ukuthatha inxaxheba",
        "OFFLINEUSER": "Ngaphandle kweintanethi",
        "PLACEHOLDER": "Hluza ngokohlobo lokuthatha inxaxheba",
        "USER": "Ku-intanethi"
      },
      "VISIBILITY": {
        "DRAFT": "Ayikapapashwa",
        "LABEL": "Ukubonakala",
        "PLACEHOLDER": "Coca ngomfanekiso",
        "PLANNED": "Icwangcisiwe",
        "PUBLISHED": "Ipapashwe"
      }
    },
    "MANAGE_FILTERS": {
      "DESCRIPTION": "Izihluzi zigciniwe kubo bonke abalawuli nabaphathi abagunyazisiweyo.",
      "NO_FILTERABLE_QUESTIONS": "Akukho sixhobo sokucoca esikhoyo.",
      "SECTION_TITLE_FORM": "Ulwazi lwefomu",
      "SECTION_TITLE_PARTICIPANTS": "Iphrofayili yabaThathi-nxaxheba",
      "TITLE": "Hlahla"
    },
    "MENU": {
      "ASSIGNMENT": "Ukuncedwa",
      "COMMUNICATION": "Iindaba",
      "CONSULTATION": "Iingcebiso",
      "FOLDER": "Amadokhumenti",
      "GENERAL": "Jikelele",
      "MESSAGING": "Imiyalezo",
      "NEWSLETTER": "Iileta zokuBhalisa",
      "PARTICIPATION": "Ukuzibandakanya",
      "SETTINGS": "Izicwangciso",
      "SETTINGS_ACCESS": "Ukufikelela",
      "SETTINGS_COMMUNICATION": "Unxibelelwano",
      "SETTINGS_GENERAL": "Jikelele",
      "SETTINGS_LEGAL": "Izicatshulwa Ezisemthethweni",
      "SETTINGS_PAGES": "Amaphepha",
      "STATS": "Isishwankathelo",
      "USER": "Abasebenzisi"
    },
    "NEWSLETTERS": "Iincwadana zeendaba",
    "PARTICIPATION": "Ukubamba iqhaza",
    "POSTS_FORM": {
      "FIELDS_CONFIG": {
        "ACTIVE": "Yenza isebenze",
        "APPLICATION_FILE_LABEL": "Ngenisa imodeli yefayile eneenkcukacha zesicelo",
        "APPLICATION_FILE_TOOLTIP": "Ukucela ulwazi oluthe vetshe kubasebenzisi xa befaka igalelo elitsha, ungabanika itemplate yefayile eneenkcukacha yesicelo.<br></br><b>Iifomati ezamkelekileyo :</b> .pdf, .doc, .docx, .txt, .odt, .rtf, .md",
        "DESCRIPTION": "Ifomu yokufaka ihambelana nolwazi olufuneka umsebenzisi alugcwalise ukuze afake igalelo lakhe.",
        "REQUIRED": "Kuyimfuneko",
        "TITLE": "Ifom yo kuhlala phantsi"
      },
      "SETTINGS_PANEL": {
        "COMMUNICATION": {
          "TITLE": "Izicwangciso zoSasazo lweendaba"
        },
        "CONSULTATION": {
          "TITLE": "Isetingi zocwaningo"
        },
        "FOLDER": {
          "TITLE": "Izicwangciso zeFayile"
        }
      },
      "TABS": {
        "ANALYSIS": "Uhlalutyo",
        "APPEARANCE": "Inkangeleko",
        "DISABLED_TOOLTIP": "Gcwalisa kwaye ugcine ifom yangoku ukuze ufikelele kule.",
        "IMPLEMENTATION": "Iziphumo",
        "MANAGERS": "Abaphathi",
        "PRESENTATION": "Intshayelelo",
        "PUBLIC_FILTERS": "Iifayile zikarhulumente",
        "QUESTIONS": "Imibuzo",
        "SECURITY": "Ukhuseleko",
        "SETTINGS": "Izicwangciso",
        "SUBMISSION": "Idiphozithi",
        "VOTE": "Vota"
      }
    },
    "PUBLIC_FILTERS": {
      "DESCRIPTION": "Yongeza uphando olunzulu kwinkuthazo yakho ukuvumela abasebenzisi bakho ukuba bacofe izimvo kwiphepha lakho.",
      "TITLE": "Izihluzi Zobuntu"
    },
    "SHOW": "Bona",
    "TABLE": {
      "ARIA_LABELS": {
        "FIRST_PAGE": "Iphepha lokuqala",
        "LAST_PAGE": "Iphepha lokugqibela",
        "NEXT_PAGE": "Iphepha elilandelayo",
        "PREVIOUS_PAGE": "Iphepha elidlulileyo"
      },
      "BUTTONS": {
        "ACTIONS": "Izenzo",
        "CHANGE_STATUS": "Guqula isimo",
        "DELETE": "Cima"
      },
      "PAGINATION": "{from}-{to} kwi {count}",
      "TITLES": {
        "ACTIONS": "Izenzo",
        "ASSIGNED": "Onoxesha",
        "AUTHOR": "Umbhali",
        "BIRTHDATE": "Umhla wokuzalwa",
        "BUDGET": "Iindleko",
        "COMMENTS_COUNT": "Izimvo",
        "COMMUNICATIONS_COUNT": "Iindaba",
        "CONSULTATION": "Uthethwano",
        "CONSULTATIONS_COUNT": "Iinkonzo zengcebiso",
        "CONSULTATION_TITLE": "Isihloko se ngxoxo",
        "CONTRIBUTION": "Igalelo",
        "CREATED_AT": "Umhla weSimumu",
        "EMAIL": "I-imeyili",
        "FIRST_NAME": "Igama lokuqala",
        "FOLDER": "Idokhumenti",
        "FOLDERS_COUNT": "Iifayile",
        "HAS_ACCESS": "Ukufikelela?",
        "ID": "ID",
        "IDEAS_COUNT": "Igalelo",
        "LAST_NAME": "Igama",
        "LAST_VOTE_AT": "Umhla wevoti",
        "NEWSLETTER_CREATED_AT": "Umhla wokuqala wenziwa",
        "NEWSLETTER_SENT_AT": "Umhla wokuthumela",
        "NEWSLETTER_SUBJECT": "Isihloko",
        "NEWSLETTER_TITLE": "incwadi yeendaba",
        "PARTICIPATION_TYPE": "Ukubamba iqhaza",
        "PICTURE": " ",
        "PUBLICATION_DATE": "Ipapashwe ngo",
        "RECIPIENTS": "Abamkeli",
        "RESPONSE_DATE": "Umhla",
        "ROLE": "Indima",
        "SENT_AT": "Umhla wokuthumela",
        "SOURCE": "Ukubandakanya",
        "STATE": "Indawo",
        "STATUS": "Isimo",
        "SUBSCRIPTION_DATE": "Umhla wokubhalisa",
        "TITLE": "Isihloko",
        "TOPIC": "Isihloko",
        "TYPE": "Uhlobo",
        "USER": "Umsebenzisi",
        "VISIBILITY": "Ukubonakala",
        "VOTES_AGAINST_COUNT": "Amavoti aphikisanayo",
        "VOTES_COUNT": "Inani leevoti",
        "VOTES_FOR_COUNT": "Amavoti evumelana ne"
      }
    }
  },
  "DATE": {
    "INPUT_FORMAT": "DD/MM/YYYY"
  },
  "DATE_TIME": {
    "DAYS_LEFT": "{count, plural, =0 {Usuku lokugqibela!} one {Kusele {count} usuku!} other {Kusele {count} iintsuku!}}",
    "INVALID_LABEL": "Ayisebenzi",
    "IN_N_DAYS": "Ukuqala {count}",
    "LABEL": {
      "DEFAULT": "Khetha umhla",
      "SCHEDULE_LABEL": "Shicilela i",
      "SCHEDULE_TITLE": "Icwangcisa ukupapashwa"
    }
  },
  "DISCUSSION": {
    "EMAIL": {
      "CONTENT": {
        "LABEL": "Umxholo we-imeyile",
        "PLACEHOLDER": "Molo, …"
      },
      "DELETED_USER_WARNING": "Lo mntu ufuna ukususa iakhawunti yakhe. Ngoko awukwazi ukunxibelelana naye.",
      "SEND": "Thumela",
      "SUBJECT": {
        "LABEL": "Isihloko se-imeyili",
        "PLACEHOLDER": "Ukucela ulwazi olongezelelweyo malunga no …"
      }
    },
    "SHOW": {
      "COMMENTS_COUNT": "{count, plural, =0 {Inqaku labucala} one {{count} Inqaku labucala} other {{count} Amanqaku abucala}}",
      "COMMENT_PLACEHOLDER": {
        "PRIVATE": "Yongeza inqaku eliyimfihlo",
        "PUBLIC": "Uluvo lwakho"
      },
      "INFO": "Qinisekisa ukuba awubhali zicaphule ezineenkcukacha ezithathwa njengezibuthathaka.",
      "INFO_TOOLTIP": "Origine yobuhlanga okanye ubuzwe, izimvo zezopolitiko, ezeenkolo okanye ezefilosofi, ubulungu bemibutho yabasebenzi, idatha yezempilo, ukukhetha kwezesondo, irekhodi lolwaphulo-mthetho, …",
      "NO_COMMENTS": "Yiba ngowokuqala ukubhala inqaku eliyimfihlo."
    }
  },
  "DUPLICATED_POSTS": {
    "TITLE": "{count, plural, =0 {# iziphumo ezifanayo ezidibaniswe kunye nale} one {{count} isiphumo esifanayo esidibaniswe kunye nale} other {{count} iziphumo ezifanayo ezidibaniswe kunye nale}}"
  },
  "ERROR_PAGES": {
    "BACK_TO_SPACE": "Buyela ekhasini lasekhaya",
    "CTA_NO_SPACE": "Fumana indawo yokuthatha inxaxheba",
    "FORMER_CLIENT_TOAST": "Indawo ozama ukuyindwendwela ayikho okanye ayisekho.",
    "NOT_FOUND": {
      "DESCRIPTION": "Kubonakala ngathi sikukhokele ngendlela engalunganga. Singaqalisa phantsi ngendlela efanelekileyo?",
      "TITLE": "Uxolo, asifumananga iphepha obulifunayo."
    },
    "OFFLINE": {
      "DESCRIPTION": "Kubonakala ngathi awukho kwi-intanethi. Siqale ngokuhlaziya?",
      "TITLE": "Uxolo, asifumananga iphepha obulikhangela."
    },
    "RELOAD": "Hlaziya",
    "SERVER_ERROR": {
      "DESCRIPTION": "Qiniseka ukuba abaphuhlisi bethu benza konke okusemandleni ukuze balungise. Kufanele sibuyele kamsinya.",
      "TITLE": "Owu, kwenzeke impazamo engalindelekanga."
    }
  },
  "FOOTER": {
    "ACCESSIBILITY": "Ukufikeleleka",
    "ETHICAL_POLICY": "Ikhadi leZimilo",
    "HELP": "Uncedo",
    "LEGAL_NOTICE": "Izaziso Ezisemthethweni",
    "PRIVACY_POLICY": "Umgaqo-nkqubo Wobumfihlo",
    "TERMS_OF_USE": "Ithemba lokusebenzisa"
  },
  "FORM": {
    "ERRORS": {
      "FILL_CORRECTLY": "Kufuneka ugcwalise imihlaba ngokuchanekileyo.",
      "REQUIRED": "Kufuneka ugcwalise le nkalo."
    },
    "SELECT_EMPTY_LABEL": "Ayichazwanga",
    "TOASTS": {
      "DELETED_SUCCESSFULLY": "Ukususwa kuphumelele ngempumelelo",
      "UPDATED_SUCCESSFULLY": "Uhlaziyo luphumelele ngempumelelo."
    }
  },
  "FORM_RESPONSES": {
    "CREATED_AT": "Iphendulwe ngomhla <b>{date}</b> ngexesha <b>{time}</b>",
    "SHOW_RESPONSE": "Jonga impendulo yam",
    "SUBMISSION_NOT_ONGOING": "Uthethwano luvaliwe, awusenako ukuphendula okanye ukuhlela impendulo yakho.",
    "UPDATE_RESPONSE": "Lungisa impendulo yam"
  },
  "GENERIC_CONFIRM_DELETE": {
    "CONTENT": "Ngaba uqinisekile ukuba ufuna ukususa le nto?",
    "CTA": "Ewe, cima",
    "TITLE": "Cima."
  },
  "HOME": {
    "PAGE_TITLE": "Wamkelekile kwi Fluicity Engage",
    "SEARCH_PLACEHOLDER": "Ngenisa igama lendawo",
    "SUBTITLE": "Fumana indawo ukuze uqale ukuthatha inxaxheba"
  },
  "IMAGE": {
    "FAILED_TO_LOAD": "Uxolo, ayiphumelelanga ukulayisha umfanekiso.",
    "LOADING": "Ukulayisha umfanekiso"
  },
  "IMPORT": {
    "CONTRIBUTIONS": {
      "HEADLINE": {
        "DESCRIPTION": "Ukuba ufuna ukongeza izabelo ezininzi ezifumaneke ngaphandle kweqonga, {link} ngaphandle kokuguqula ifomathi.<br></br>Ukuba awuqokelelanga ulwazi oluthile, nceda ungacimi iikholamu uze uzishiye zingenanto.<br></br>Ukuba izabelo zakho zikwiilwimi ezininzi, nceda uziguqulele zonke ku {defaultLang} ngaphambi kokungenisa.",
        "LINK": "gcwalisa imodeli",
        "TITLE": "Ngenisa izipho"
      },
      "STATUS": {
        "DESCRIPTION": "Ukubonisa isimo seminikelo ngexesha lokungeniswa kwedatha",
        "TITLE": "Khetha imeko-bume"
      }
    },
    "ERROR": {
      "DESCRIPTION": "Andikupheleki ukungenisa ifayile yakho. Qinisekisa ukuba ifayile yakho ilandela imodeli kakuhle.",
      "EXPLANATION": "Qinisekisa ukuba akukho sikhonkwane esisusiweyo kwaye iimpendulo zihambelana nefomathi eceliweyo.",
      "ROWS_MULTIPLE": "Andikwazi ukungenisa ifayile yakho. Iimpazamo zifumaneke kumgca {rows}.",
      "ROWS_SINGLE": "Andikwazi ukungenisa ifayile yakho. Kukhona impazamo efunyenweyo kumgca {rows}.",
      "ROWS_WITH_MORE": "Andikwazi ukungenisa ifayile yakho. Iimpazamo zifunyenwe kumgca {rows} kunye {moreCount} abanye."
    },
    "FORM": {
      "CTA": "Ngenisa",
      "UPLOAD_DATE": "{size} - Ukuhlaziywa ngo-{date}",
      "UPLOAD_TITLE": "Tsala umxholo okanye ucofe"
    },
    "FORM_RESPONSES": {
      "HEADLINE": {
        "DESCRIPTION": "Ukuba ufuna ukufaka iimpendulo ezininzi ezifunyenwe ngaphandle kweqonga, {link} ngaphandle kokutshintsha ifomathi.<br></br>Ukuba awuqokelelanga olunye ulwazi, nceda ungasicimi iikholamu kwaye uzishiye zingenanto.<br></br>Ukuba iimpendulo zakho zikwiziilwimi ezininzi, nceda uziguqulele zonke ku-{defaultLang} phambi kokuzifaka.",
        "LINK": "gcwalisa imodeli",
        "TITLE": "Ngenisa iimpendulo"
      }
    },
    "PREVIEW": {
      "DESCRIPTION": "Qinisekisa ukuba ulwazi lwakho olungenisiweyo luhambelana neekholamu zesampulu.<br></br>Ukuba kukho ulwazi olungahambelaniyo, kufuneka ulungelelanise ifayile yakho kwaye uyenise ifayile yakho ehlaziyiwe.",
      "TITLE": "Hlola idatha"
    },
    "PROGRESS": "Ukungenisa kuyaqhuba…",
    "VOTERS": {
      "HEADLINE": {
        "DESCRIPTION": "Ukuba ufuna ukongeza amavoti afunyenwe ngaphandle kweqonga, {link} ngaphandle kokutshintsha ifomathi. Ukuba awuqokelelanga ezinye iinkcukacha, nceda <b>ungazisusi iikholamu</b> kwaye uzishiye zingenanto.",
        "LINK": "gcwalisa imodeli",
        "TITLE": "Ngenisa amavoti"
      }
    }
  },
  "JOIN": "Joyina",
  "JOINED_SPACE": "Us joined {space}, wamkelekile!",
  "KEEP_ME_ALIVE": {
    "ALERT": {
      "CONTENT": "Siza kukugcina uhlaziywa ukuba kukho iingxelo ezifanelekileyo kuwe ezikwi-airtime kwixesha elizayo. Ungafumanisa ezinye iindawo ezikhoyo usebenzisa uphendlo olungezantsi kwaye ungene ngemvume usebenzisa iakhawunti yakho yangoku.",
      "CONTENT_NOT_FOUND": "Ukuba ufuna ukuthatha inxaxheba kwakhona kwingxoxo, nceda wenze iakhawunti entsha.",
      "TITLE": "Enkosi ngokukhetha ukugcina i-akhawunti yakho isebenza!",
      "TITLE_NOT_FOUND": "I-akhawunti yakho ayisekho okanye sele yenziwe ingaziwa!"
    }
  },
  "LOADING_MORE": "Ukulayisha…",
  "LOAD_MORE": "Bona ngakumbi",
  "MENU_ITEMS": {
    "DESCRIPTION": "Lungisa amakhadi abonakala kubha yakho yokuhamba.",
    "FORM": {
      "ADD_ITEM": "Engeza ithebhu",
      "ADD_SUBITEM": "Yongeza ithebhu engezantsi",
      "INPUTS": {
        "LABEL": {
          "LABEL": "Isihloko",
          "PLACEHOLDER": "Nceda uchaze isihloko sethebhu yakho."
        },
        "LINK": {
          "LABEL": "I-External Link",
          "PLACEHOLDER": "https://site.com"
        },
        "PAGE": {
          "LABEL": "Iphepha elingagqibekanga",
          "PLACEHOLDER": "Khetha iphepha"
        },
        "POST": {
          "LABEL": "Umxholo",
          "NO_OPTIONS": "Akukho mveliso ifunyenweyo",
          "PLACEHOLDER": "Khangela umxholo"
        },
        "POST_CATEGORY": {
          "COMMUNICATION": "Iindaba",
          "CONSULTATION": "Iinkonzo zokubonisana",
          "FOLDER": "Ifayile",
          "LABEL": "Uhlobo lomxholo",
          "PLACEHOLDER": "Khetha uhlobo lomxholo"
        },
        "TYPE": {
          "LABEL": "Uhlobo",
          "PLACEHOLDER": "Khetha uhlobo"
        }
      }
    },
    "GROUP": "Imenyu yokudonsa phantsi",
    "LINK": "Isixhumanisi esingaphandle",
    "NEW_GROUP": "IMENYU ENTSHA EHLAYO",
    "NEW_ITEM": "INTO EN ELEMENT ENTSHA",
    "PAGE": "Iphepha elingagqibekanga",
    "PAGE_ABOUT": "Ngokuphathelene",
    "PAGE_CONSULTATIONS": "Iingcebiso",
    "PAGE_NEWS": "Iindaba",
    "PAGE_SEARCH": "Khangela",
    "POST": "Umxholo",
    "TITLE": "Ibha yephenyane yakho"
  },
  "MESSAGING_BLOC": {
    "ANOMALY": {
      "REPORT_CTA": "Bika iphutha"
    },
    "DEMAND": {
      "REPORT_CTA": "Thumela umyalezo"
    }
  },
  "META_TAGS": {
    "DEFAULT_DESCRIPTION": "Fluicity Engage yisixazululo sokuzibandakanya kwabantu, evumela ukuthathwa kwezigqibo ngokuhlangeneyo malunga nezihloko ezinomdla kuluntu.",
    "PAGES_TITLES": {
      "ABOUT": "Malunga | {spaceName}",
      "CONSULTATIONS": "Iintlanganiso | {spaceName}",
      "CONTRIBUTIONS": {
        "MESSAGING": "Imiyalezo yam kunye neziphene | {spaceName}",
        "PROPOSALS": "Iminikelo yam | {spaceName}"
      },
      "DASHBOARD": "Ideshibhodi | {spaceName}",
      "LEGAL_NOTICE": "I apologize, here's the correct translation:\n\nIinkcukacha zomthetho | {spaceName}",
      "NEWS": "Iindaba | {spaceName}",
      "PRIVACY_POLICY": "Umgaqo-nkqubo Wabucala |{spaceName}",
      "SEARCH": "Phendla | {spaceName}",
      "SETTINGS": "Iakhawunti yam | {spaceName}",
      "TERMS_OF_USE": "Iimeko zokusebenzisa | {spaceName}"
    },
    "STATUS_TO_SHARE": {
      "ARTICLE": "{cityName} : funda eli nqaku kwi Fluicity Engage!",
      "EVENT": "{cityName} : joyina lo mcimbi!",
      "FOLDER": "{title} {url}",
      "IDEA": "Xhasa lo mnikelo: {title} {url}"
    },
    "TITLE_TO_SHARE": {
      "FOLDER": "{isihloko}",
      "IDEA": "Xhasa le nqophiso : {title}"
    }
  },
  "MODERATION": {
    "MODAL": {
      "DESCRIPTION": "Ungayitshintsha igalelo lakho okanye ulithumele njengoko linjalo. Iinkonzo ziya kuvavanya ukuba igalelo lakho lingapapashwa na.",
      "REASON": "Isizathu:",
      "SUBMIT": "Hambisa",
      "TITLE": "Umnikelo wakho ubonelelwe njengosoloko."
    }
  },
  "MOMENT": {
    "DATE": {
      "DEFAULT": "DD/MM/YYYY",
      "PLACEHOLDER": "JJ/MM/AAAA"
    }
  },
  "NAVBAR": {
    "DASHBOARD": "Ibhodi yeDashi",
    "MY_ACCOUNT": "I-akhawunti yam",
    "MY_PROFILE": "Iprofayili yam"
  },
  "NEWSLETTERS": {
    "ALREADY_SENT": "Le ncwadana sele ithunyelwe",
    "CREATED_AT": "Idalwe ngomhla ka-<b>{date}</b> ngo-<b>{time}</b>",
    "DRAFT": "Brouillon",
    "FORM": {
      "CLEAR_SCHEDULING": "Ukucinywa kohlengahlengiso.",
      "CONTENT": {
        "LABEL": "Umxholo",
        "PLACEHOLDER": "Umxholo we-imeyile"
      },
      "RECIPIENTS": {
        "ALL": "Bonke abasebenzisi",
        "LABEL": "Abamkeli",
        "PLACEHOLDER": "Khetha abamkeli"
      },
      "SAVE_SUCCESS": "Incwadi yakho yeendaba igcinwe ngempumelelo.",
      "SCHEDULE": "Hlela ukuthumela",
      "SCHEDULED_AT": "Umhla wokuthumela",
      "SEND": "Thumela",
      "SEND_SUCCESS": "Iphephandaba lakho lithunyelwe ngempumelelo",
      "SEND_TEST": "Thumela uvavanyo",
      "SUBJECT": {
        "LABEL": "Isihloko",
        "PLACEHOLDER": "Isihloko se-imeyile"
      },
      "TEST_EMAIL": {
        "LABEL": "I-imeyili zokuvavanya",
        "PLACEHOLDER": "Ngenisa iidilesi ze-imeyile zovavanyo (zahlulwe ngezikoma)"
      },
      "TEST_SUCCESS": "Inowethi yovavanyo ithunyelwe ngempumelelo"
    },
    "IMMEDIATELY": "Ngokukhawuleza",
    "NEW_NEWSLETTER": "Yenza incwadana yeendaba",
    "SCHEDULED": "Icwangcisiwe",
    "SENT": "Iphumile",
    "SENT_AT": "Ithunyelwe nge <b>{date}</b> nge <b>{time}</b>",
    "UPDATE_NEWSLETTER": "Hlela i-newsletter",
    "USERS_FILTER_COUNT": "{count, plural, =0 {Akukho mntu ufumanekileyo kolu khetho} one {Incwadana yakho yeendaba iza kuthunyelwa kumntu omnye} other {Incwadana yakho yeendaba iza kuthunyelwa kubantu abayi-{count}}}"
  },
  "NEXT": "Emva koko",
  "NONE": "Akukho nto",
  "NOTIFICATIONS_SETTINGS": {
    "ADMINISTRATOR": {
      "DAILY_DIGEST": {
        "DESCRIPTION": "Consultations :<br />• Igalelo elitsha<br />• Iimpendulo ezintsha kwiingxelo<br />• Xa ummi ephendula kwelinye lamagqabaza<br />• Xa isigaba okanye ingxoxo isondele esiphelweni<br /><br />Imiyalezo :<br />• Imiyalezo emitsha<br />• Iziphene ezintsha<br />• Xa ummi ephendula kwelinye lamagqabaza",
        "SUBTITLE": "imihla ngemihla",
        "TITLE": "Imisebenzi yakutshanje"
      },
      "SUBSCRIBED_ACTIVITIES_NOTIFICATIONS": {
        "DESCRIPTION": "• Ukutshintshwa kwegalelo ngumbhali wayo<br />• Ukulawulwa komxholo liqela le-Fluicity Engage",
        "TITLE": "Abanye"
      }
    },
    "CITIZEN": {
      "CONSULTATIONS_NOTIFICATIONS": {
        "DESCRIPTION": "• Uphononongo olutsha<br />• Ukuqala kwesigaba sokucinga, sokuvota okanye iziphumo",
        "TITLE": "Iingxoxo"
      },
      "DAILY_DIGEST": {
        "DESCRIPTION": "• Ingxelo okanye ivoti kwelam igalelo<br />• Uphendule kwingxelo yam<br />• Utshintsho kwimeko yegalelo lam",
        "SUBTITLE": "(kwemihla)",
        "TITLE": "Imisebenzi yakho yakutshanje"
      },
      "NEWSLETTER_NOTIFICATIONS": {
        "DESCRIPTION": "• Iileta zeendaba eziphathelele umsebenzi weqonga",
        "TITLE": "Iileta ezivela kwiindaba"
      },
      "SUBSCRIBED_ACTIVITIES_NOTIFICATIONS": {
        "DESCRIPTION": "• Ukususwa kwenkxaso oyiphawulileyo<br />• Ukuhlela umxholo owuphawulileyo",
        "TITLE": "Ezinye"
      },
      "WEEKLY_DIGEST": {
        "DESCRIPTION": "• Izihloko ezintsha<br />• Izehlo ezintsha<br />• Igalelo eliphambili",
        "SUBTITLE": "veki-ngelosi",
        "TITLE": "Ngoku kwi-space"
      }
    },
    "INFO_BOX_TEXT": "Khetha apha izaziso ze-imeyile ofuna ukuzifumana kwiqonga."
  },
  "NPS_FORM": {
    "CONTENT_FIELD": "Kutheni?",
    "EXTREMELY_LIKELY": "Ngokwenene",
    "NOT_LIKELY": "Hayi kwaphela",
    "TITLE": "Sincede kuthi siphucule i-Fluicity Engage",
    "VALUE_QUESTION": "Ngaba ungacebisa Fluicity Engage kumlingani?"
  },
  "OFFLINE": "Ngaphandle kweintanethi",
  "ONLINE": "Kwi-Intanethi",
  "OR": "OKANYE",
  "ORIGINAL_POST": {
    "NO_OPTIONS": "Akukho mnikelo onokukhethwa",
    "TITLE": "Le nkonzo le yenziwe yahlanganiswa nenkonzo efanayo elandelayo"
  },
  "PAGE_OF": "Ikhasi {current} kwe {total}",
  "PASSWORD_RESET": {
    "ACTION": "hlaziya",
    "ARIA_LABEL": "Guqula ukubonakala kwephasiwedi",
    "PAGE_TITLE": "Yenza iphasiwedi entsha",
    "TITLE": "Yenza iphasiwedi entsha",
    "TOAST": "Igama lokugqitha elitsha ligciniwe."
  },
  "PASSWORD_RESET_REQUEST": {
    "HOMEPAGE_LINK": "Buyela kwiphepha lasekhaya",
    "LINK_SENT": "Ukuba i-akhawunti inxulumene ne-imeyile <strong>{email}</strong>, uza kufumana ikhonkco lokusetha kwakhona. <br></br><br></br>Ukuba awuboni i-imeyile, khangela kwibhokisi yakho yemfucuza.",
    "PAGE_TITLE": "Setha kabusha iphasiwedi yakho",
    "RESET": "Cwangcisa kwakhona",
    "SUB_TITLE": "Ulibele iphasiwedi yakho? Kuyehla nakubani! Siza kukuthumelela i-imeyile enekhonkco lokuyibuyisela.",
    "TITLE": "Setha kwakhona iphasiwedi yakho"
  },
  "PICTURE_PICKER": {
    "COVER": "Khetha umfanekiso ukuze ubonise iposti yakho."
  },
  "POSTS": {
    "AUDITS": {
      "CREATE": "kwadalwa {date}",
      "MODAL": {
        "AFTER": "Emva kohlengiso",
        "BEFORE": "Ngaphambi kokuguqulwa",
        "TITLE": "Imbali"
      },
      "NO_AUDITS": "Le nkcaso ayikabi ixesha.",
      "UPDATE": "Illungiswe {date}"
    },
    "AUTHOR": "Umbhali",
    "BUDGET": {
      "ALERT": "Kufuneka <b>ungenise iindleko</b> zomnikelo ngaphambi kokuba uwuchaze njenge “Retenue”.",
      "BUDGET_VALUE": "Le oluvo lubiza <b>{budget}</b>",
      "MODAL_LABEL": "Indleko yegalelo",
      "MODAL_TITLE": "Ngenisa iindleko",
      "NOT_ENOUGH_BUDGET": "Uxanduva olushiyekileyo alwanelanga.",
      "NOT_SELECTED": "Le ngxoxo ayizange yamkelwe kwinqanaba lokuvota.",
      "REMAINING_BUDGET": "Usasele <strong>{remaining}</strong> ongasayichitha"
    },
    "CARD": {
      "CONTRIBUTE": "Ngenisa isandla",
      "PARTICIPATE": "Nxaxheba",
      "READ_MORE": "Nxibelelana",
      "VOTE": "Vota"
    },
    "CAROUSEL": {
      "PROGRESS": {
        "TOOLTIP_1": "{progress, plural, =0 {{progress} ivoti} one {{progress} ivoti} other {{progress} ivoti}}",
        "TOOLTIP_2": "{total, plural, =0 {kwi-{total} igalelo} one {kwi-{total} igalelo} other {kwi-{total} amagalelo}}"
      },
      "PROMPT": {
        "PROPOSAL_CARD": {
          "CTA": "Umnikelo",
          "TEXT_1": "Okanye ukuba unomdla wokuphefumlelwa",
          "TEXT_2": "Siyenza igalelo?"
        },
        "VOTE_CARD": {
          "CTA": "Voter",
          "TEXT_1": "Usele uhambile kwizipho zombalwa {emoji}",
          "TEXT_2": "siyaqhuba?",
          "TEXT_3": "okanye ubone uluhlu olupheleleyo"
        }
      }
    },
    "CLONE": {
      "ACTION": "Phinda-phinda",
      "CANCEL": "Hayi",
      "CONFIRM": "Ewe, phinda-phinda",
      "CONTENT_CLONED": "Lo mxholo luphindwe ngempumelelo.",
      "DESCRIPTION": "Uyafuna ngempela ukuphinda okuqukethwe?",
      "SUCCESS": "Lo mxholo ususiwe."
    },
    "COMMENTS_COUNT": "{count, plural, =0 {Izimvo} one {Izimvo} other {Izimvo}}",
    "CONSULTATIONS": {
      "BE_THE_FIRST_TO_PARTICIPATE": "Yiba ngowokuqala okanye ngowesibini ukuthatha inxaxheba!",
      "CONSULTATIONS_COUNT": "{count, plural, =0 {{count} uthethwano} one {{count} uthethwano} other {{count} iintetho}}",
      "ENDED_AT": "Ukubonisana kugqityiwe nge {date}",
      "FEED_TITLE": {
        "IDEAS_COUNT": "{itemCount, plural, =0 {Akukho galelo} one {# igalelo} other {# amagalelo} }",
        "LOCATED_IDEAS_COUNT": "{itemCount, plural, =0 {Akukho galelo elifumanekayo} one {1 igalelo elifumanekayo} other {# amagalelo afumanekayo}}"
      },
      "MAP_TOOLTIP": "Izavenge ezingekho kwindawo azibonakali kwimephu. Inzuzo inokuba neendawo ezininzi.",
      "NEWS_COUNT": "{count, plural, =0 {iindaba} one {{count}indaba} other {{count}iindaba}}",
      "ONGOING_TEXT": "Xhuma apha ukuze ubambe iqhaza.",
      "PARTICIPATE_OFF": "Hlalutya apha kungekudala ukuze ube negalelo kwiindidi!",
      "POST_SIDE_PRIMARY_ACTION": {
        "IMPLEMENTATION": "Fumanisa iziphumo",
        "PARTICIPATE": "Nxaxheba kwingxoxo-mpikiswano"
      },
      "SEE_OWN_VOTES": "Bona kuphela iivoti zam",
      "STARTS_AT": "Ukubonisana kuqala ngomhla we-{date}",
      "STEP_ENDED_AT": "Inyathelo “{step}” liphelile ngo-{date}",
      "STEP_STARTS_AT": "Sihlangane nge {date} ukuze sifumanise isigaba “{step}”"
    },
    "CONTENT_DELETED_SUCCESSFULLY": "umxholo ususiwe",
    "CREATE_MENU": {
      "ACTIONS": "Izenzo",
      "ADDED_TO_FOLDER_TOAST": "Umxholo wongeziwe kwifolda.",
      "ADD_TO_FOLDER": "Yongeza kwifolda",
      "ARTICLE": {
        "DESCRIPTION": "Ukubeka phambili isiganeko okanye inyathelo elitsha"
      },
      "ASSIGN": "Ukwabela",
      "BUTTON": "Dala",
      "COLLABORATIVE_DECISION": {
        "DESCRIPTION": "Ukuphumeza igalelo elakhiwe ngokubambisana kunye nabasebenzisi"
      },
      "CONTACT_AUTHOR": "Nxibelelana nombhali",
      "DIALOG_TITLE": {
        "COMMUNICATION": "Yenza isiganeko esisha",
        "CONSULTATION": "Yenza ingxoxo"
      },
      "EDIT": "Guqula",
      "EVENT": {
        "DESCRIPTION": "Cela umenywa ukuba athathe inxaxheba kwintlanganiso"
      },
      "FOLDER": {
        "DESCRIPTION": "Yenza iphepha lokugxilisa iziqulatho."
      },
      "IDEAS_REQUEST": {
        "DESCRIPTION": "Ukuqokelela igalelo kwimicimbi yakho yobuchule"
      },
      "MERGE": "Qokelela igalelo",
      "PARTICIPATORY_BUDGET": {
        "DESCRIPTION": "Nikwa isabelo mali kwiintlawulo ezakhiwe kunye nabasebenzisi"
      },
      "PIN": "Beka kwindawo ephambili",
      "REMOVED_FROM_FOLDER_TOAST": "Umxholo ususiwe kwifolda.",
      "REPORT": "Bika",
      "STEPS_COUNT": "{count, plural, one {# inyathelo} other {# amanyathelo}}",
      "STUDY": {
        "DESCRIPTION": "Faka uphando olwenziwe ngaphandle kweqonga",
        "TITLE": "Ibhinqa - Udibaniselwano"
      },
      "SURVEY": {
        "DESCRIPTION": "Cela iqula abasebenzisi ngendaba ethile kwaye baqokelele ulwazi olunentsingiselo."
      },
      "UNPIN": "Susa ekufakeni ebaleni.",
      "UNPUBLISH": "Ukukhupha kuwonke-wonke",
      "UPDATE_BUDGET": "Ukufaka ulwazi lwebhajethi",
      "UPDATE_STATUS": "Guqula isimo",
      "VIEW": "Jonga iposti",
      "VIEW_IN_DASHBOARD": "Ideshibhodi",
      "VIEW_POST": "Bona isithuba"
    },
    "DELETE": {
      "ACTION": "Cima",
      "CANCEL": "Hayi",
      "CONFIRM": "Ewe, susa",
      "CONTENT_DELETED": "Lo mxholo ususiwe.",
      "DESCRIPTION": "Ngaba uyafuna ngokwenene ukususa olu hlobo?",
      "PLACEHOLDER": "Faka uluvo ukuze uchaze ukususwa kwakho.",
      "REASON": "Impendulo",
      "SELECT_REASON": "Khangela isizathu sokususa okuqukethwe:",
      "SUCCESS": "Lo mxholo ususiwe."
    },
    "DETAILS": {
      "AUTHORED_BY": "Ephethwe ngu{name}",
      "DESCRIPTION_TITLE": "Inkcazelo",
      "EVENT": {
        "ACCESS_THE_EVENT": "Fikelela isiganeko",
        "EVENT_URL": "Intlanganiso yevidiyo",
        "STATE": {
          "FUTURE": "Lo msitho uqala ngomhla ka-<b>{date}</b> ngentsimbi ye-<b>{time}</b>.",
          "ONGOING": "Umnyhadala uyenzeka ngoku",
          "PAST": "Umsitho uphelile"
        }
      },
      "MORE_TAGS": "{count, plural, one {kwaye enye ingqondo} other {kwaye {count} ezinye iingqondo}}",
      "STUDY": {
        "JOIN_BUTTON": "Joyina",
        "JOIN_DESCRIPTION": "Ngena okanye ubhalise ukuze ufikelele kwingcebiso!",
        "PARTICIPATE": "Ukubamba iqhaza",
        "POST_SIDE_DESCRIPTION": {
          "COMING": "Ukuhlolwa kuqala ngomhla {date}.",
          "ENDED": "Ukubonisana kugqityiwe nge-{date}.",
          "ONGOING_ANSWERED": "Ndiyabulela ngokuthatha inxaxheba, ithathelwe ingqalelo ngempumelelo."
        },
        "SEE_RESULTS": "Jonga iziphumo"
      },
      "UPDATE_MY_IDEA": "Umenzi"
    },
    "EXPORT": {
      "BUTTON": "Thumela ngaphandle",
      "IDEAS": "Zonke iingeniso",
      "MESSAGES": "Zonke iincwadi"
    },
    "FILTER_BY_IS_PINNED": "KwiNdaba eziGqwesileyo",
    "FILTER_BY_PUBLISHED": "Ipapashwe",
    "FILTER_BY_STATUS": "Isimo",
    "FILTER_BY_TAGS": "Umxholo",
    "FILTER_BY_TYPE": "Uhlobo lomxholo",
    "FILTER_IS_PINNED_TRUE": "Ewe",
    "FILTER_PUBLISHED_FALSE": "Ayikashicilelwa",
    "FILTER_PUBLISHED_TRUE": "Ipapashwe",
    "FILTER_STATUS_ANSWERED": "Ayikhangeleka",
    "FILTER_STATUS_DOING": "Ukuhlalutya kuqhubeka",
    "FILTER_STATUS_DONE": "Iminyathiselwe",
    "FILTER_STATUS_IN_PROGRESS": "Ukwenziwa kuyenzeka",
    "FILTER_STATUS_SELECTED": "Ukubanjwa",
    "FILTER_STATUS_TODO": "Idipozithwa",
    "FILTER_STATUS_VALIDATED": "Iphumelele",
    "FILTER_TYPE_ANOMALY": "Iphutha",
    "FILTER_TYPE_ARTICLE": "Inqaku",
    "FILTER_TYPE_COLLABORATIVE_DECISION": "Ukubonisana",
    "FILTER_TYPE_DEMAND": "Umyalezo",
    "FILTER_TYPE_EVENT": "Isiganeko",
    "FILTER_TYPE_FOLDER": "Ifayile",
    "FILTER_TYPE_IDEA": "Igalelo",
    "FILTER_TYPE_IDEAS_REQUEST": "Isicelo sokungeniswa kwegalelo",
    "FILTER_TYPE_PARTICIPATORY_BUDGET": "Ulungelelwano lwezibonelelo zokuthatha inxaxheba",
    "FILTER_TYPE_STUDY": "Ihlolaview",
    "FOLDER": {
      "IS_OPEN_TO_PROPOSITIONS": "Vulekele kwiingcebiso ezizimeleyo"
    },
    "FORM": {
      "ADDRESS": {
        "LABEL": "Indawo",
        "PLACEHOLDER": "Yongeza indawo"
      },
      "CATEGORIES": {
        "LABEL": "Izingqangi",
        "PLACEHOLDER": "Khetha izihloko zengxoxo",
        "SELECT_ALL": "Khetha konke"
      },
      "CATEGORY": {
        "LABEL": "Umxholo",
        "PLACEHOLDER": "Khetha umxholo"
      },
      "CONTENT": "Inkcazo",
      "PICTURE": {
        "BUTTON": {
          "ADD_FILE_OR_PICTURE": "Yongeza ifayile/umfanekiso",
          "ADD_PICTURE": "Yongeza umfanekiso",
          "DELETE_PICTURE": "Cima"
        },
        "ERRORS": {
          "FILE_SIZE": "Umfanekiso akufunekanga ube mkhulu ngaphezu kwe-{fileSize}Mo.",
          "FILE_TYPE": "Umfanekiso kufuneka ube kwifomathi {fileTypes}."
        },
        "TOOLTIP": "<b>Ubukhulu obunconyiweyo:</b> {width} (ububanzi) nge {height} ama-pixels (ubude) <br></br> <b>Iifomati ezamkelekileyo:</b> .jpg, .jpeg, .png"
      },
      "PIN": "Lo mxholo uxinenjongo.",
      "TITLE": "Isihloko",
      "UNPIN": "Lo mqulu awusengowona umxholo ophambili."
    },
    "HOW_IT_WORKS": {
      "TITLE": "Kusebenza njani?"
    },
    "INDICATORS": {
      "ATTENDEES": "Abathathi-nxaxheba",
      "COMMENTS": "Izimvo",
      "COMMUNICATIONS": "Iindaba",
      "CONSULTATIONS": "Iinkokhelo",
      "IDEAS": "Igalelo",
      "VOTES": "{online_count, plural, =0 {{online_count} ivoti ezinkqutyana} one {{online_count} ivoti ezinkqutyana} other {{online_count} ivoti ezinkqutyana}} - {offline_count, plural, =0 {{offline_count} ivoti ezingekho kwi-intanethi} one {{offline_count} ivoti ezingekho kwi-intanethi} other {{offline_count} ivoti ezingekho kwi-intanethi}}"
    },
    "INTERACTIONS_BOX": {
      "CONTINUE_CONVERSATION": "Qhubekani ingxoxo",
      "GIVE_YOUR_OPINION": "Nikela uluvo lwakho"
    },
    "PREVIEW": "Bona kwiwebhusayithi",
    "PUBLIC_STUDY": "Uphando loluntu",
    "PUBLISHED": "Ipapashwe",
    "PUBLISHED_AT": "Ipapashwe ngo-{date}",
    "PUBLISH_CANCELED": "Ukupapashwa kwesi siqulatho kurhoxisiwe.",
    "PUBLISH_EDIT": "Lungisa isicwangciso",
    "PUBLISH_NOW": "Shicilela ngoku",
    "PUBLISH_NOW_TOASTER": "Umxholo wakho ngoku uyabonakala kubasebenzisi.",
    "PUBLISH_SCHEDULED": "Icwangcisa ukupapashwa",
    "REPORT": {
      "ACTION": "Bika",
      "CODE_OF_ETHICS": "ikhathalelo yokuziphatha",
      "CONFIRM": "Thumela",
      "EMPTY_ERROR": "Kufuneka ugcwalise ngokuchanekileyo amasimi.",
      "FLUICITY_TERMS_PART_A": "Funda kabanzi malunga ne-",
      "FLUICITY_TERMS_PART_B": "et la",
      "FLUICITY_TERMS_PART_C": "de Fluicity Engage.",
      "PLACEHOLDER": "Nceda faka izimvo zakho ukuchaza ingxelo yakho.",
      "SELECT_REASON": "Nceda uchaze ukuba kutheni ubika lo mxholo:",
      "SUCCESS": "Enkosi ngale ngxelo. Isivumela ukuba siqinisekise umgangatho weziqulatho ku-Fluicity Engage.",
      "TERMS_OF_USE": "Iimfuno Jikelele"
    },
    "RESPONSES_COUNT": "{count, plural, =0 {Impendulo} one {Impendulo} other {Iimpendulo}}",
    "SAVE": "Gcina",
    "SAVE_THE_DRAFT": "Gcina ikopi oyilayibrari",
    "SCHEDULE": "Umhlohli wekhompyutha",
    "SCHEDULED": "Icwangcisiwe",
    "SCHEDULED_AT": "Planiwe ngo-{date}",
    "SCHEDULED_AT_TOASTER": "Ukupapashwa kwesi siqulatho kuhlelwe umhla we-{date}",
    "SEE": {
      "COLLABORATIVE_DECISION": "Bona umhlangano wokubonisana",
      "FOLDER": "Jonga ifayile",
      "IDEA": "Bona iGalelo",
      "IDEAS_REQUEST": "Jonga isicelo sokungenisa izindululo",
      "PARTICIPATORY_BUDGET": "Bona i-bhajethi yokubambisana"
    },
    "SHOW": {
      "FROM_DATE_TO_DATE_WITH_TIME": "Ukusuka <strong>{startAtDate} ngo-{startAtHour}</strong> ukuya ku-<strong>{endAtDate} ngo-{endAtHour}</strong>",
      "QR_CODE": {
        "BLACK_AND_WHITE": "Mnyama nomhlophe",
        "DOWNLOAD": "Landa",
        "GENERATE": "Gqinisekisa i-QR code",
        "TITLE": "Ikhodi ye-QR"
      },
      "SHARE_IT": "Yabelana"
    },
    "SORT": {
      "BUTTON": "Hlela",
      "POPULAR": "Ipholula",
      "RECENT": "Kutsha nje"
    },
    "STATS": {
      "TITLE_PARTICIPATION": "Isishwankathelo sokuthatha inxaxheba"
    },
    "STATUS": {
      "FORM_TITLE": "{count, plural, =0 {Guqula isimo} one {Guqula isimo} other {Guqula isimo: {count} igalelo elikhethiwe}}",
      "MODAL": {
        "TITLE": "Ukuphuhliswa kwenkxaso-mali"
      },
      "ORIGINAL_POST": {
        "LABEL": "Inhloko yegalelo lokuqala eliya kugcinwa",
        "TITLE": "Ngenisa isihloko somnikelo wokuqala apho le mnikelo uya kudibaniswa khona:"
      },
      "POPOVER": {
        "BUTTON": "Funda ngokugqithisileyo"
      },
      "SUBMIT": "Gcina",
      "TITLE": "Isimo",
      "UPDATED_SUCCESSFULLY": "Isimo sigciniwe."
    },
    "STEPS": {
      "STATES": {
        "AVAILABLE": "Fumaneka",
        "COMING": "Uzayoza",
        "ENDED": "I apologize for the oversight. Here's the correct translation:\n\nGqityiwe",
        "ENDLESS": "Qhubekeka",
        "ONGOING": "Kuqhubeka"
      },
      "TABS": {
        "LABEL": "Amasele ebakala lezigaba zokupapasha"
      }
    },
    "SUMMARY": {
      "TITLE": "Isishwankathelo sokufaka isandla",
      "TOOLTIP": "Le isishwankathelo senziwe ngoncedo lwengqondo yokufakelwa ukuze ukuncedisa ukufunda igalelo."
    },
    "TAGS": {
      "PERIOD": "Ukusukela <strong>{startAtDate} nge-{startAtHour}</strong> ukuya ku-<strong>{endAtDate} nge-{endAtHour}</strong>",
      "PERIOD_SAME_DAY": "Ngo<strong>{startAtDate}</strong> ukusuka <strong>{startAtHour}</strong> ukuya <strong>{endAtHour}</strong>",
      "PERIOD_SHORT": "Ukusukela <strong>{startAtDate}</strong> ukuya <strong>{endAtDate}</strong>"
    },
    "TYPES": {
      "ANOMALY": "Iphutha",
      "ARTICLE": "Inqaku",
      "COLLABORATIVE_DECISION": "Uthethathethwano",
      "DEMAND": "Umyalezo",
      "EVENT": "Isiganeko",
      "FOLDER": "Ishicilelo",
      "IDEA": "Igalelo",
      "IDEAS_REQUEST": "Isicelo sokungeniswa kwemibono",
      "PARTICIPATORY_BUDGET": "Uhlahlo-lwabiwo mali oluthathiwe",
      "STUDY": "Umbuzo",
      "SURVEY": "Iphepha leMibuzo"
    },
    "UPDATED": "Umxholo uhlaziyiwe ngempumelelo"
  },
  "POST_FORM": {
    "ACTION_SAVE": "Gcina",
    "ADMIN_UPDATE_ALERT": "Xa uhlengahlengisa igalelo, sithumela isaziso nge-imeyile kumbhali. Ukuqinisekisa ukuba umbhali uyavuma utshintsho lwakho, sicebisa ukuba umqhagamshele ngqo kwangaphambili.",
    "APPLICATION_FILE": "Ngenisa ifayile yakho eneenkcukacha zefayile yakho yokufaka isicelo",
    "APPLICATION_FILE_BUTTON": "Yongeza ifolda",
    "APPLICATION_FILE_TOOLTIP": "Ukungenisa igalelo lakho, kufuneka unikeze ifayile eneenkcukacha zesicelo. Kule nto, gcwalisa imodeli ebonelelweyo kwaye uyifake apha ngezantsi.<br></br><br></br Ngokungafaniyo nolwazi olunikezelwe kwifom yesicelo (isihloko, inkcazo, isihloko, njl.) olwaziswa esidlangalaleni, umxholo wefayile uya kufikeleleka kuphela ngabaphathi beqonga.<br></br><br></br><b>Iifomati ezamkelekileyo:</b> .pdf, .doc, .docx, .txt, .odt, .rtf, .md",
    "ATTACHMENTS": {
      "DESCRIPTION": {
        "COMMUNICATION": "Yabelana amaxwebhu ongezelelweyo afana nemifanekiso okanye ividiyo kwiindaba zakho.",
        "CONSULTATION": "Yabelana amaxwebhu ongezelelweyo afana nomthetho wakho, imifanekiso okanye ividiyo kwiingcebiso zakho.",
        "FOLDER": "Yabelana amaxwebhu ongezelelweyo anjengemifanekiso okanye ividiyo kwifayile yakho."
      },
      "TITLE": "Iifayile eziqhotyoshelweyo"
    },
    "ATTACHMENTS_FILES": "Iifayile",
    "ATTACHMENTS_IMAGES": "Imifanekiso",
    "ATTACHMENTS_TITLE": "Amaxwebhu",
    "AUTHORED_BY": "Ngubani umlobi?",
    "AUTHORED_BY_A_THIRD_PARTY": "Umntu wesithathu",
    "AUTHORED_BY_A_THIRD_PARTY_PLACEHOLDER": "Umntu ongaphandle kweqonga",
    "AUTHORED_BY_CUSTOM": "Ngesiko",
    "AUTHORED_BY_CUSTOM_PLACEHOLDER": "Umbutho, iqela labemi, indibano…",
    "AUTHORED_BY_FIRST_NAME": "Igama lombhali",
    "AUTHORED_BY_FIRST_NAME_PLACEHOLDER": "Umzekelo: UJean",
    "AUTHORED_BY_LAST_NAME": "Igama lombhali",
    "AUTHORED_BY_LAST_NAME_PLACEHOLDER": "Umzekelo: Dupont",
    "AUTHORED_BY_MYSELF": "Mna.",
    "AUTHORED_BY_MY_SPACE": "Umbutho wam",
    "BUDGET": "Uqikelelo lweSabelomali",
    "BUDGET_PLACEHOLDER": "Nceda uchaze uhlahlo-lwabiwo mali",
    "CHOOSE_A_FOLDER": "Khetha ifolda",
    "CONTENT": "Inkcazelo",
    "CONTRIBUTION_KIND": {
      "CUSTOM_LABEL": "Uhlobo lomnikelo",
      "CUSTOM_PLACEHOLDER": "Chaza uhlobo lwegalelo ofuna ukuliqokelela.",
      "DESCRIPTION": "Lungisa ileyibheli leqhosha (CTA) ukuthumela iminikelo.",
      "OPTIONS": {
        "CONTRIBUTION": "Igqokelelo",
        "OTHER": "Enye",
        "PROPOSAL": "Isiphakamiso",
        "QUESTION": "Umbuzo",
        "REPORT": "Ingxelo"
      },
      "PREVIEW": "Ukuphawula :",
      "TITLE": "Uhlobo lwesipho"
    },
    "DEFAULT_PROPOSAL_VIEW": {
      "OPTIONS": {
        "CAROUSEL": {
          "DESCRIPTION": "Ukukhuthaza iimpendulo (uvoto oluqinisekileyo okanye olungaqinisekiyo)",
          "NAME": "Carrousel"
        },
        "LIST": {
          "DESCRIPTION": "Ukuba ufuna ukubonisa ngokufutshane zonke izabelo",
          "NAME": "Uluhlu"
        },
        "MAP": {
          "DESCRIPTION": "Ukuze ubonise indawo yezipho.",
          "NAME": "Ikhadi"
        }
      },
      "SUBTITLE": "Yenzani ngokwezifiso iphepha lenkomfa yakho ngokukhetha umbono ozenzakalelayo wezabelo. Kuzo zonke iimeko, abasebenzisi baya kuba nakho ukukhetha umbono ohlukileyo.",
      "TITLE": "Ukubonisa igalelo"
    },
    "DESCRIPTION": "Inkcazelo",
    "DESCRIPTION_SECTION": {
      "DESCRIPTION": {
        "COMMUNICATION": "Le ngxenye le inika ithuba lokuchazela abasebenzisi umxholo kunye nemiceli mngeni yeendaba zakho.",
        "CONSULTATION": "Le ngxenye le inika ithuba lokuchazela abasebenzisi umongo kunye nemiceli mngeni yengxoxo yakho.",
        "FOLDER": "Le ngxenye lesi sivumela ukuchazela abasebenzisi umongo kunye nemiceli mngeni yefayile yakho."
      },
      "TITLE": "Inkcazelo yendlela yokwenza izinto"
    },
    "DISPLAY_OPTIONS": {
      "CHILDREN_LIST_PICTURES": {
        "LABEL": "Bonisa imifanekiso yegalelo kuluhlu",
        "TITLE": "Umfanekiso"
      },
      "COMMENTS_ENABLED": {
        "LABEL": "Vula amagqabaza phantsi kophando lwakho"
      },
      "GEOJSON": {
        "DESCRIPTION": "Yenza ngokwezifiso imephu ngezindawo zejografi kunye neendawo ezinomdla ku-{link} uze unamathisele ikhowudi engezantsi.",
        "TITLE": "Ukumisela imephu ngendlela oyifunayo"
      }
    },
    "EDIT": {
      "TITLE": {
        "ANOMALY": "Lungisa iphutha",
        "COMMUNICATION": "Lungisa iindaba zakutshanje",
        "CONSULTATION": "Lungisa udliwanondlebe",
        "DEMAND": "Hlela umyalezo",
        "FOLDER": "Lungisa ifolda",
        "IDEA": "Lungisa igalelo"
      }
    },
    "EDITORS_FORM": {
      "DESCRIPTION": "Ukunika umsebenzisi ukufikelela, kufuneka abe yi-<i>Umphathi</i> wendawo. Kuphela <i>uMlawuli</i> onokunika lo msebenzi.",
      "SUBTITLE": "Uluhlu lwabasebenzisi abane-access yokulawula le ngxoxo.",
      "TITLE": "Abaphathi"
    },
    "END_AT": "Umhla kunye nexesha lokuphela",
    "ERRORS": {
      "FILL_FIELDS": "Kufuneka ugcwalise iinkalo ngokuchanekileyo.",
      "LOCATION_NOT_IN_THE_LIST": "Kufuneka ukhethe idilesi kuluhlu."
    },
    "EVENT_URL_LABEL": "Intlanganiso yevidiyo",
    "EVENT_URL_PLACEHOLDER": "Nceda faka i-URL yengqungquthela yevidiyo ye-Zoom, Jitsi, Teams, Meet, njl.",
    "FORM_BUILDER": {
      "ACCEPTED_ANSWERS": "Impendulo evumelekileyo",
      "ACCEPTED_ANSWERS_DATE_DESCRIPTION": "Qinisekisa umhla onikwe ngumsebenzisi ngomhla oyireferensi.",
      "ACCEPTED_ANSWERS_OPERATOR_LABEL": "Khetha umsebenzisi womsebenzi",
      "ACCEPTED_ANSWERS_QUESTION_OPTIONS_DESCRIPTION": "Khetha impendulo nganye enokwenzeka.",
      "ACCEPTED_ANSWERS_SUMMARY": "Iimpendulo ezivunyelweyo",
      "ACCEPTED_ANSWERS_TEXT_DESCRIPTION": "Yahlula impendulo nganye evumelekileyo ngomgca omtsha.",
      "ACCEPTED_ANSWERS_TEXT_PLACEHOLDER": "Impendulo 1  \nImpendulo 2  \nImpendulo 3  \nImpendulo 4",
      "ADD_DESCRIPTION": "Yongeza inkcazo",
      "ADD_QUESTION": "Yongeza umbuzo",
      "ADD_SECTION": "Yongeza isiqendu",
      "CONFIDENTIAL": "Imfihlo",
      "CONFIDENTIAL_INFORMATION_NOTICE": "Impendulo yakho iyakubonakala kuphela ngabaphathi beqonga.",
      "CONFIDENTIAL_QUESTION": "Umbuzo oyimfihlo",
      "CONFIDENTIAL_QUESTION_DESCRIPTION": "Impendulo iya kubonakala kuphela ngabalawuli kunye nabaphathi abanamalungelo.",
      "DATE_OPERATOR": {
        "EQ": "yile",
        "GT": "ngaphezu kwe",
        "GTE": "ingaphezulu okanye ilingana ne",
        "LT": "ngaphantsi kwe-",
        "LTE": "ngaphantsi okanye ilingana ne",
        "NOT_EQ": "akukho"
      },
      "DEFAULT_FIELD_INFO": "Ngokuzenzekelayo",
      "DESCRIPTION_LABEL": "Inkcazelo",
      "DESCRIPTION_PLACEHOLDER": "Umzekelo: Lo mbuzo uza kusivumela ukuba sikwazi ukwazi ngcono.",
      "DROPDOWN_QUESTION": "Uluhlu oludlekayo",
      "DROPDOWN_QUESTION_DESCRIPTION": "Izinketho ziya kuboniswa kuluhlu oluqulunqileyo.",
      "MAXLENGTH": "Nciphisa inani lezinhlamvu",
      "MAXLENGTH_DESCRIPTION": "Ngenisa inani eliphezulu leempawu ezivumelekileyo",
      "MAXLENGTH_LABEL": "Inani labalinganiswa",
      "MAXLENGTH_PLACEHOLDER": "Okungenamkhawulo",
      "MAXLENGTH_SUMMARY": "Oonobumba abuninzi.",
      "OPTIONS": {
        "ADD_OPTION": "Yongeza inketho",
        "ADD_OTHER": "Yongeza « Enye »",
        "OR": "okanye",
        "OTHER": "Enye"
      },
      "OPTION_LABEL": "Option {index}",
      "PLACEHOLDER": "Impendulo yakho",
      "QUESTION_LINKS": {
        "DESCRIPTION": "Bonisa xa impendulo ku ...",
        "OPERATOR": {
          "BLANK": "ikhalile",
          "CONTAINS": "iqulethe",
          "EQ": "ngu",
          "GT": "ongaphezulu kuka",
          "GTE": "ingaphezulu okanye lilingana ku",
          "LT": "ngaphantsi kwe",
          "LTE": "ingaphantsi okanye ilingana ne",
          "NOT_CONTAINS": "akukhoqulatheki",
          "NOT_EQ": "akukho",
          "PRESENT": "ayikho ingenanto"
        },
        "OPERATOR_LABEL": "Umsebenzisi",
        "OPTIONS_LABEL": "Iinketho",
        "QUESTION_LABEL": "Umbuzo",
        "TITLE": "Ukuboniswa kombuzo"
      },
      "QUESTION_LINKS_SUMMARY": "Imeko yeMfundo",
      "REQUIRED": "Kuyimfuneko",
      "REQUIRED_QUESTION": "Umbuzo oyimfuneko",
      "SUBMIT_FORM": "Ngenisa ifomu",
      "SURVEY_DESCRIPTION_1": "Iimibuzo ziqulathe imibuzo ofuna ukuyibeka kubasebenzisi bakho.",
      "SURVEY_DESCRIPTION_2": "Lungiselela iphepha lemibuzo ngokuhambelana nengxoxo yakho.",
      "SURVEY_TITLE": "Iphepha lembuzo",
      "TITLE_LABEL": "Umbuzo",
      "TITLE_PLACEHOLDER": "Umzekelo : Yimalini iminyaka yakho?",
      "TYPES": {
        "ATTACHMENT": "Izincamathelisi",
        "CHECKBOX": "Iimpendulo ezininzi",
        "DATE": "Umhla",
        "LOCATION": "Indawo yokuhlala",
        "MONEY": "Uhlahlo-lwabiwo mali",
        "PHONE_NUMBER": "Inombolo yomnxeba",
        "PICTURE": "Umfanekiso wokugubungela",
        "RADIO": "Impendulo enye",
        "SECTION": "Icandelo",
        "TEXT": "Impendulo emfutshane",
        "TEXTAREA": "Ishicilelo",
        "TITLE": "Uhlobo lwendawo"
      },
      "TYPE_SELECT_WARNING": {
        "DESCRIPTION_1": "Usuvele uqokelele iimpendulo zalombuzo.",
        "DESCRIPTION_2": "Ukuba uyayitshintsha, iimpendulo ezinxulumene nayo ziya kucinywa ngokupheleleyo.",
        "DESCRIPTION_3": "Ngaba uyazidinga ezi datha? Khuphela iimpendulo zakho ngaphambi kokuba ucime lo mbuzo kunye/okanye ukhetho.",
        "TITLE": "Ngaba uqinisekile?"
      }
    },
    "GENERAL_INFO": "Ulwazi Jikelele",
    "IMAGE": "Umfanekiso",
    "LOCALISATION_LABEL": "Indawo okanye idilesi",
    "LOCALISATION_MARKER_PLACED": "Isikhombandlela sibekwe",
    "LOCALISATION_MODAL_NEGATIVE_BUTTON": "Cima",
    "LOCALISATION_MODAL_NOTICE_TEXT": "Cofa kwimephu ukuze ubeke uphawu.",
    "LOCALISATION_MODAL_POSITIVE_BUTTON": "Ukuqinisekisa",
    "LOCALISATION_MODAL_TITLE": "Yongeza indawo",
    "LOCALISATION_NO_RESULTS": "Nceda chwetheza ukuze ufumane iingcebiso",
    "LOCALISATION_PLACEHOLDER": "Yongeza indawo",
    "LOCALISATION_SEE_MAP": "Jonga imephu",
    "MODERATABLE": {
      "LABEL": "Ukumodareyitha phambi kokupapashwa",
      "TOOLTIP": "Zonke iintlawulo kufuneka zivunywe ngumlawuli ukuze zipapashwe kwaye zibonakale kwabanye abasebenzisi."
    },
    "NEW": {
      "ANOMALIES": {
        "DESCRIPTION_PLACEHOLDER": "Nceda ubhale inkcazelo ecacisa ngengxaki ehlangene nendlela yayo. Yenza ukuba ibe semngciphekweni ukuze kube lula ukuyilungisa.",
        "MODAL_DESCRIPTION": "{spaceName} uzokuphendula ngokukhawuleza.",
        "MODAL_TITLE": "Amathamsanqa, iphutha lithunyelwe!",
        "SIDEBAR_ACTION": "Thumela",
        "SIDEBAR_DESCRIPTION": "Inhlangano ikulungele ukumamela kwaye izakuphendula kwakamsinya.",
        "TITLE": "Ndiyazisa into engalunganga",
        "TITLE_PLACEHOLDER": "Ndifuna ukubika…"
      },
      "ARTICLES": {
        "DESCRIPTION_PLACEHOLDER": "Ngenisa umxholo weendaba zangoku okanye uveze inyathelo, ngenjongo yokwazisa rhoqo malunga namanyathelo amatsha kunye nokusasaza ulwazi olufundisayo.",
        "MODAL_DESCRIPTION": "Sele kwisibonakaliso ngoku kwabanye abasebenzisi besithuba esi. {isPrivateSpace, select, true {} other {Yabelana ngayo kumajelo onxibelelwano ukuze inyuse ukubonakala kwayo.}}",
        "MODAL_TITLE": "Amhlophe, inqaku lipapashiwe!",
        "PROBLEMATIC_PLACEHOLDER": "Chaza ngelizwi elinye inqaku lakho ukuze libe nomtsalane.",
        "TITLE": "Yenza inqaku",
        "TITLE_PLACEHOLDER": "Bhala isihloko esivusa umdla kubasebenzisi."
      },
      "COLLABORATIVE_DECISIONS": {
        "DESCRIPTION_PLACEHOLDER": "Nceda unike iinkcukacha malunga nomxholo wale ngxoxo. Cacisa iindlela zokuthatha inxaxheba ukwenzela ukuba abasebenzisi bakwazi ukuthatha inxaxheba ngendlela efanelekileyo kuphando lwezisombululo.",
        "MODAL_DESCRIPTION": "Ilingoku ngoku uyabonakala kwabanye abasebenzisi. Libethelele ekhasini lakho lasekhaya ngokulenza libe ligqame ukuze libonakale ngakumbi.",
        "MODAL_TITLE": "Camagu, iingxoxo zipapashiwe!",
        "PROBLEMATIC_PLACEHOLDER": "Kwenze kube nomtsalane kubasebenzisi ukuba bathathe inxaxheba ngesivakalisi esinye.",
        "SIDEBAR_ACTION": "Shicilela",
        "TITLE": "Ukwenza intlanganiso yokubonisana",
        "TITLE_PLACEHOLDER": "Bhala isihloko esivusa umdla kubasebenzisi."
      },
      "DEMANDS": {
        "DESCRIPTION_PLACEHOLDER": "Cacisa umongo womyalezo ngokuchaza zonke izinto eziza kunceda ukucacisa isihloko sakho.",
        "MODAL_CTA": "Jonga iimiyalezo zam",
        "MODAL_DESCRIPTION": "Umamkeli uza kufumana isaziso ngokukhawuleza. Ungayifumana le myalezo nangaliphi na ixesha kwimenyu ethi \"Imiyalezo yam & iziphene\" kwiprofayile yakho.",
        "MODAL_TITLE": "Camagu, umyalezo uthunyelwe!",
        "SIDEBAR_ACTION": "Thumela",
        "SIDEBAR_DESCRIPTION": "Lo mxwebhu luyimfihlo. Kuphela umsebenzisi kunye nabaqalisi abanokuyibona.",
        "TITLE": "Thumela umyalezo",
        "TITLE_PLACEHOLDER": "Ndicela ukufumana ulwazi ngo…"
      },
      "EVENTS": {
        "CONFIGURATION": {
          "DESCRIPTION": "Le ngxenye likuvumela ukuba uchaze kubasebenzisi umhla kunye nendawo (idilesi kunye / okanye ikhonkco levidiyo yentlanganiso) yomnyhadala.",
          "TITLE": "Iindlela zokuthatha inxaxheba"
        },
        "DESCRIPTION_PLACEHOLDER": "Ngenisa umxholo wesiganeko kwaye wazise abasebenzisi malunga neemeko zokuzimasa.",
        "MODAL_DESCRIPTION": "Sele ngoku ibonwa ngamanye amalungu. Yabelana ngayo kwimidiya yoluntu ukuze uyinike ubungakanani obukhulu.",
        "MODAL_TITLE": "Camagu, isiganeko sipapashiwe!",
        "PROBLEMATIC_PLACEHOLDER": "Chaza ngentetho enye umcimbi wakho ukuze unike umdla wokufunda ngawo",
        "SIDEBAR_ACTION": "Shicilela",
        "TITLE_PLACEHOLDER": "Bhala isihloko esivusa umdla kubasebenzisi."
      },
      "FOLDERS": {
        "DESCRIPTION_PLACEHOLDER": "Nceda unike iinkcukacha malunga nesiqulatho salo mbandela. Chaza iindlela zokuthatha inxaxheba ukuze abasebenzisi bakwazi ukuthatha inxaxheba ngokufanelekileyo ekufuneni izisombululo.",
        "MODAL_DESCRIPTION": "Ubonakalisa kwabanye abasebenzisi. Yigxininise kwi-akhawunti yakho ekhaya ukuze ibonakale ngakumbi.",
        "MODAL_TITLE": "Camagu, idokhumenti ipapashiwe!",
        "PROBLEMATIC_PLACEHOLDER": "Faka isivakalisi esikhuthazayo esiphathelene nefayile yakho.",
        "SIDEBAR_ACTION": "Shicilela",
        "TITLE_PLACEHOLDER": "Bhala isihloko esivusa umdla kubasebenzisi."
      },
      "IDEAS": {
        "DESCRIPTION_PLACEHOLDER": "Chaza igalelo lakho kunye nendlela esebenza ngayo.",
        "MODAL_CTA": "Jonga igalelo lam",
        "MODAL_DESCRIPTION": "Fumanisa zonke iziphumo zakho kwiprofayile yakho.",
        "MODAL_DESCRIPTION_GUEST": "Ukulandela inkqubela-phambili yayo kunye nokufumana uhlaziyo, yenza i-akhawunti. Ngaphandle kokubhalisa, awuyi kuba nakho ukubona impembelelo yayo okanye waziswe ngeevoti kunye nezimvo.",
        "MODAL_TITLE": "Enkosi ngokuthatha inxaxheba yakho",
        "REDIRECT": "Uxhulumanisi olukhankanyiweyo alubonakali lusebenza. Fumana ingxoxo kuluhlu ukuze ukwazi ukufaka igalelo lakho.",
        "TITLE": "Gcwalisa ifomu",
        "TITLE_PLACEHOLDER": "Singathini ukuba…",
        "WITHOUT_MODERATION": {
          "SIDEBAR_ACTION": "Papasha",
          "SIDEBAR_DESCRIPTION": "Nje ukuba ipapashwe, abanye abasebenzisi baya kukwazi ukwandisa igalelo lakho ngokunikezela ngeengcebiso."
        },
        "WITH_MODERATION": {
          "SIDEBAR_ACTION": "Ngenisa",
          "SIDEBAR_DESCRIPTION": "Inkcitho iya kupapashwa xa sele iqinisekisiwe ngabasebenzi."
        }
      },
      "IDEAS_REQUESTS": {
        "DESCRIPTION_PLACEHOLDER": "Nceda unike iinkcukacha malunga nomxholo walesi simemo sokungenisa izindululo. Chaza indlela yokuthatha inxaxheba ukuze abasebenzisi bakwazi ukuthatha inxaxheba ngendlela efanelekileyo kuphando lwezisombululo.",
        "MODAL_DESCRIPTION": "Iye ngoku sele ibonwa ngabasebenzisi abanye. Yincamathelise kwiphepha lakho lasekhaya ngokuyenza ibe ngundoqo ukuze ibonakale ngakumbi.",
        "MODAL_TITLE": "Amhlophe, isimemo sokufaka izindinyana sishicilelwe!",
        "PROBLEMATIC_PLACEHOLDER": "Nika umnqweno kubasebenzisi wokuzimasa ngentetho emfutshane.",
        "SIDEBAR_ACTION": "Shicilela",
        "TITLE_PLACEHOLDER": "Bhala isihloko esivusa umdla kubasebenzisi."
      },
      "PARTICIPATORY_BUDGETS": {
        "DESCRIPTION_PLACEHOLDER": "Nceda unike iinkcukacha malunga nomxholo wolu hlahlo lwabiwo-mali lwentsebenziswano. Cacisa iindlela zokuthatha inxaxheba ukuze abasebenzisi bakwazi ukuthatha inxaxheba ngendlela efanelekileyo kuphando lwezisombululo.",
        "MODAL_DESCRIPTION": "Sele ngoku ibonakala kwabanye abasebenzisi. Yibeke kwiphepha lakho lasekhaya ngokuyibeka kwindawo ephambili ukuze ibonakale ngakumbi.",
        "MODAL_TITLE": "Jongani, isicwangciso-mali elithathe inxaxheba lipapashiwe!",
        "PROBLEMATIC_PLACEHOLDER": "Nika umnqweno kubasebenzisi bokuthatha inxaxheba ngomhlathi omnye.",
        "SIDEBAR_ACTION": "Papasha",
        "TITLE_PLACEHOLDER": "Bhala isihloko esivusa umdla kubasebenzisi."
      },
      "STUDIES": {
        "DESCRIPTION": "Uxwebhu luhlobisa ifom ye-enkcazelo eyenziwe ngaphandle kweqonga ku-Typeform, Google Form, Survey Monkey, Tally okanye nawaphi na amanye amaqonga avumela ukudalwa kweefom.",
        "DESCRIPTION_PLACEHOLDER": "Nceda unike iinkcukacha malunga nemeko yale ngcebiso kunye neendlela zokuthatha inxaxheba kuyo.",
        "FORM_DESCRIPTION": "Yongeza amakhonkco ophando lwakho ukuze wabelane ngalo kwiqonga lakho.",
        "MODAL_DESCRIPTION": "Ibonakalisa ngoku kwabanye abasebenzisi. Yabelana ngayo kumajelo onxibelelwano ukuze uyinike ubungakanani obungakumbi.",
        "MODAL_TITLE": "Amathamsanqa, uphando lusemthethweni!",
        "PROBLEMATIC_PLACEHOLDER": "Nika umnqweno kubasebenzisi wokuthatha inxaxheba ngomhlathi omnye.",
        "SIDEBAR_ACTION": "Papasha",
        "STUDY_ID_PLACEHOLDER": "Exemple: https://fluicity.typeform.com/to/A1b2C3d4",
        "STUDY_RESULT_PLACEHOLDER": "Isibonelo: https://fluicity.typeform.com/report/A1b2C3d4/E5f6G7h8",
        "STUDY_RESULT_TITLE": "Isiphumo soqhagamshelwano",
        "STUDY_TITLE": "Ikhonkco loPhando",
        "TITLE_PLACEHOLDER": "Bhala isihloko esidonsa umdla wabasebenzisi."
      },
      "TITLE": {
        "ANOMALY": "Dala ingxaki",
        "COMMUNICATION": "Yenza iindaba",
        "CONSULTATION": "Dala umbono",
        "DEMAND": "Yenza umyalezo",
        "FOLDER": "Yenza ifolda",
        "IDEA": "Yenza igalelo"
      }
    },
    "POST_PUBLISHED": "Lo mxholo ngoku upapashiweyo.",
    "POST_PUBLISHED_AT": "Ipapashwe ngomhla we-{date} ngexesha le-{time}",
    "POST_SAVED": "Izigqibo ziye zagcinwa.",
    "POST_SCHEDULED": "Lo mxholo uhleliwe ngo-{date} nge-{time}",
    "PROBLEMATIC": "Accroche",
    "PUBLICATION_CANCELLED": "Ukupapashwa kuye kwarhoxiswa ngempumelelo.",
    "SIMILAR_PROPOSALS": "Abanye abasebenzisi babonakala ngathi babelane ngegalelo elifanayo:",
    "START_AT": "Umhla kunye nexesha lokuqala",
    "STEPS": {
      "CONFIGURATION": "Ukucushwa kwesigaba",
      "DESCRIPTION": "Le ngxenye le ikuvumela ukuba unxibelelane nabasebenzisi iintsuku ezibalulekileyo zengxoxo.",
      "DESCRIPTION_TABS": "Amathebhu enkcazelo yezigaba ngeelwimi ezininzi",
      "END_AT_HELPER_TEXT": "Ukhetho ngokwemigangatho eqhubekayo",
      "IMPLEMENTATION": {
        "ADMIN_ONLY_PLACEHOLDER": "Qinisani ukongeza \"Isihlomelo seziphumo\" kwaye niqinisekise useto lokuvula ukhetho.",
        "ADMIN_ONLY_TEXT": "Bonisa iziphumo zocwaningo",
        "SURVEYS": {
          "ADMIN_ONLY_PLACEHOLDER": "Uxwebhu olupheleleyo lufaka zonke iziphumo zophando, umbuzo ngombuzo. Liyinxalenye ebalulekileyo yokubonisa ukucaca kubasebenzisi.",
          "ADMIN_ONLY_TEXT": "Bonisa iziphumo zocwaningo"
        }
      },
      "PLACEHOLDER": "Chaza inkqubo yesigaba esi.",
      "SUBMISSION": {
        "ADMIN_ONLY_PLACEHOLDER": "Bonke abasebenzisi banako ukuthumela igalelo kwinkqubo yokubonisana. Ukuba ukhetho lukhutshaziwe, ngoko kuphela abalawuli abanokuthi benze igalelo elitsha.",
        "ADMIN_ONLY_TEXT": "Idipo ivulekile kubasebenzisi"
      },
      "TITLE": "Ulungiselelo lokuhamba komsebenzi"
    },
    "TITLE": "Isihloko",
    "UNDERSTOOD": "Ndivile!",
    "VIDEO": "Ividiyo",
    "VIDEO_HELPER": "Ungabelana kuphela ngevidiyo ye-Youtube okanye ye-Vimeo.",
    "VIDEO_LABEL": "Ikhonkco levidiyo",
    "VIDEO_PLACEHOLDER": "Umzekelo: http://www.youtube.com/watch?=id okanye http://vimeo.com/id",
    "VOTING_OPTIONS": {
      "BUDGET_RULE": {
        "LABEL": "Nciphisa amajelo (OK) kwisicwangciso mali esisele esingu-{count}",
        "TITLE": "Isithintelo sebudget"
      },
      "MIN_MAX": {
        "MAX_LABEL": "Inani eliphezulu lovoti",
        "MIN_LABEL": "Inani elincinci leevoti ezifunekayo",
        "TITLE": "Inani leenkxaso ezabelweyo"
      },
      "TYPE": {
        "BUDGET": {
          "DESCRIPTION": "Abasebenzisi baya kukwazi ukuxhasa igalelo de kube ukuphela kwemali iyonke. Igalelo kufuneka libe nohlahlo-lwabiwo mali.",
          "NAME": "Ngokwephepha"
        },
        "DOUBLE": {
          "DESCRIPTION": "Abasebenzisi baya kukwazi ukuxhasa igalelo ngendlela elungileyo okanye embi. Isetyenziswa rhoqo xa kunokubakho igalelo okanye ukusabela.",
          "NAME": "Kuba okanye Ngokuchasene"
        },
        "SINGLE": {
          "DESCRIPTION": "Abasebenzisi baya kukwazi ukuxhasa igalelo ngendlela elungileyo kuphela. Le modyuli isetyenziswa rhoqo xa uluvo lwakho lucwangcisa isigaba sokuvota.",
          "NAME": "Kuba"
        },
        "SUBTITLE_1": "Iindlela zokuvota zivumela abasebenzisi ukuba baxhase igalelo elenziwe kwinkxoxo yakho.",
        "SUBTITLE_2": "Lungiselela iimeko ngokweprojekthi yakho",
        "TITLE": "Iindlela zokuvota"
      },
      "UNLIMITED": "Okungenamkhawulo"
    }
  },
  "POST_STEPS_TYPES": {
    "DEFAULT": {
      "ANALYSIS": "Ukuhlalutya",
      "CONTRIBUTION": "Igalelo",
      "IMPLEMENTATION": "Iziphumo",
      "SUBMISSION": "Indawo yokugcina",
      "VOTE": "Vota"
    },
    "STUDY": {
      "IMPLEMENTATION": "Iziphumo",
      "SUBMISSION": "Impendulo"
    }
  },
  "PREVIOUS": "Edlule",
  "PROFILE": {
    "ADDRESS": "Commune",
    "BIRTHDATE": "Umhla wokuzalwa",
    "CROSS_SPACES_WARNING": "Ulwazi olungezantsi lujongene nazo zonke iindawo ozidibanisileyo.",
    "FIRST_NAME": "Igama lokuqala",
    "LAST_NAME": "Igama",
    "NAME_IS_PRIVATE": "Abanye abasebenzisi baza kukubona njengo: {displayName}",
    "NATIONAL_ID": "Inombolo yeregistri kazwelonke",
    "PRIVATE_INFORMATION_NOTICE": "Ezi nkcukacha ziya kusetyenziswa kuphela ngeenjongo zobalo-manani ezinxulumene nokuthatha inxaxheba.",
    "PROFILE_UPDATED": "Iphrofayili ihlaziyiwe.",
    "SEX": "Isini",
    "SEX_FEMALE": "Femme",
    "SEX_HELPER": "Kanye kuboniswe kwi-ID yakho yelizwe. Le datha, xa sele ihlanganisiwe, ithelekiswa neenkcukacha-manani ezibonelelwa ngamaqumrhu esizwe okanye umbutho ngokwawo.",
    "SEX_MALE": "Indoda",
    "SEX_UNSPECIFIED": "Ayichazwanga",
    "SOCIOPROFESSIONAL_CATEGORY": "Udidi lobuGcisa noMsebenzi",
    "TITLE": "I-akhawunti yam"
  },
  "PUBLISHING_POST_DIALOG": {
    "NO_QUESTIONS_WARNING": "Ngaphambi kokuba ukwazi ukupapasha lo mxholo, kufuneka {link} kwifom.",
    "NO_QUESTIONS_WARNING_LINK_TEXT": "faka imibuzo",
    "PARENT_WARNING": "Ngaphambi kokuba ukwazi ukupapasha ezi ziqulatho, kufuneka upapashe {link}.",
    "PUBLISH": {
      "BUTTON": "Shicilela ngoku",
      "CONTENT": "Ngaba uyafuna ngenene ukupapasha?",
      "NO": "Hayi",
      "TOAST": "Lo mqulu upapashiweyo.",
      "YES": "Ewe, shicilela"
    },
    "SCHEDULE": {
      "BUTTON": "Lungiselela ukupapashwa",
      "CONTENT": "Ngaba ngokwenene ufuna ukuhlela?",
      "NO": "Hayi",
      "TOAST": "Lo msebenzi ucwangcisiwe.",
      "YES": "Ewe, hlela"
    },
    "UNPUBLISH": {
      "BUTTON": "Ukungashicileli",
      "CHILDREN_WARNING": "Xa ukhupha oku kumaphepha, konke okukuyo nako kuya kuvalwa ({childrenCount}).",
      "CONTENT": "Ngaba ufuna ngokwenene ukuphinda ungapapashi?",
      "NO": "Hayi",
      "TOAST": "Lo mxholo uphelisiwe.",
      "YES": "Ewe, khupha kwi-intanethi"
    },
    "UNSCHEDULE": {
      "BUTTON": "Rhoxisa isicwangciso",
      "CONTENT": "Ngaba uyafuna ngenene ukurhoxisa ucwangciso?",
      "NO": "Hayi",
      "TOAST": "Ukucwangciswa kokuqukethwe kuye kwarhoxiswa.",
      "YES": "Ewe, rhoxisa ucwangciso"
    }
  },
  "QUESTIONS": {
    "RESULTS": {
      "ANSWERS_COUNT": "{count, plural, =0 {Akunaphendulo} one {{count} impendulo} other {{count} iimpendulo}}"
    }
  },
  "SEARCH": {
    "BUTTON": "Ukufuna",
    "CATEGORIES_PLACEHOLDER": "Hlunga nge sihloko",
    "EMPTY_SEARCH": {
      "NEW_SEARCH": "Qala ngokuthayipha amagama angundoqo kubha yokukhangela.",
      "NO_RESULTS": "Qinisekisa ukuba yonke into uyibhale ngokuchanekileyo. Ungazama nokunciphisa okanye ukuguqula ukufuna kwakho."
    },
    "INPUT_PLACEHOLDER": "Ukukhangela",
    "RESULTS_COUNT": "{count, plural, =0 {Akukho ziphumo} one {{count} isiphumo} other {{count} iziphumo}}",
    "TYPES_PLACEHOLDER": "Hluza ngohlobo lomxholo"
  },
  "SECURED_STRATEGIES": {
    "BACK_TO_POST": "Buyela ekuhloleni",
    "BIRTHDATE": {
      "TITLE": "Usuku lokuzalwa"
    },
    "CSAM": {
      "TITLE": "Ukungena nge-CSAM"
    },
    "CTA": "Nxaxheba",
    "DESCRIPTION": "<b>Lo ngxoxo ikhuselekile.</b> Ukufikelela kuyo, kufuneka uqinisekise idatha edweliswe ngezantsi kwaye ufake ezo zingekhoyo.<conditional> Ngalo naliphi na ixesha, ungasebenzisa amalungelo akho okufikelela, okulungisa kunye nokucima le datha ngokunxibelelana ne-dpo@flui.city.</conditional>",
    "DIMENSIONS": {
      "ERROR": "Ngelishwa, ulwazi enilunikezileyo alunakuvumela ukuba nithathe inxaxheba kuhlolo-mpendulo. Hlela idatha yenu okanye buyelani kuhlolo-mpendulo.",
      "TITLE": "Imilinganiselo"
    },
    "INLINE_DESCRIPTION": "<b>Le ngxoxo lo lukhuselekile.</b> Ukufikelela kulo, kufuneka ufake idatha efunekayo. Nanini na, ungasebenzisa amalungelo akho okufikelela, okulungisa kunye nokucima le datha ngephepha leprofayili yakho ukuba unayo iakhawunti okanye nge-imeyile kwi dpo@flui.city.",
    "NATIONAL_ID": {
      "ERROR": "Kufuneka ufake inombolo yerejista esebenzayo equlathe amanani ayi-11.",
      "TITLE": "Inombolo yesazisi sikazwelonke"
    },
    "PENDING_VERIFICATION_TOOLTIP": "Ukuthatha kwakho inxaxheba kuya kuthathelwa ingqalelo kuphela <b>emva kokuqinisekisa amaxwebhu akho</b>.",
    "PREVENT_GO_IDENTITY": {
      "BACK": "Emva (ikhadi elitsha lesazisi kuphela)",
      "FORM": {
        "DESCRIPTION": "Nceda unike amacala omabini esazisi sakho (i-JPEG, JPG, PNG, HEIC, WEBP okanye i-PDF, ubukhulu obucetyiswayo yi-2MB).<br></br>Ezamkelekileyo kuphela: <ul><li>Ikhadi lesazisi sikazwelonke</li><li>IPaspoti yaseFransi</li><li>Iphepha-mvume lokuqhuba (uhlobo olutsha lwekhadi letyala)</li></ul>",
        "GENERIC_ERROR": "Kwenzeke impazamo ngexesha lokulayisha amaxwebhu akho. Nceda ujonge imeko yonxibelelwano lwakho okanye uphinde uzame kamva. Unokuzama nokunciphisa ubungakanani bexwebhu (ubukhulu obucetyiswayo yi-2MB).",
        "SUCCESS_TOAST": "Isazisi sakho siqinisekisiwe ngempumelelo."
      },
      "FRONT": "Recto",
      "NO": "Hayi",
      "TITLE": "Isazisi",
      "YES": "Ewe"
    },
    "PROOF_OF_RESIDENCY": {
      "ACCEPTED_DOCUMENTS": "Kuvunyelwe kuphela: <ul><li>Inkontileka yombane, igesi okanye amanzi yakutshanje</li><li>Inkontileka yefowuni yasekhaya okanye ephathekayo</li><li>Inkontileka yomholo</li><li>Isiqinisekiso se-inshorensi yezindlu (umlilo, iingozi zorhwebo okanye uxanduva loluntu)</li><li>Ikhadi levoti</li><li>Isaziso sentlawulo</li></ul>",
      "BUTTON_DISABLED_TOOLTIP": "Kuqala kufuneka uqinisekise isazisi sakho ukuze uthumele ubungqina bendawo yokuhlala yakho.",
      "DESCRIPTION": "Nceda unike isiqinisekiso sedilesi (kwifomathi ye-JPEG, JPG, PNG, HEIC, WEBP okanye iPDF, ubukhulu obucetyiswayo yi-2MB).",
      "DOCUMENT_CONFIRMATION": "Emva kokuqinisekiswa liqela lethu, i-imeyile iya kuthunyelwa kuwe ukuqinisekisa ukuthatha kwakho inxaxheba.",
      "TITLE": "Isiqinisekiso sendawo yokuhlala"
    },
    "QUESTIONS": {
      "INCORRECT_VALUE": "Le ixabiso eli alichanekanga."
    },
    "SIGNUP_INVITATION": "Ukuba ungathanda <b>ukufumana i-imeyile yokuqinisekisa</b> ngokuthatha kwakho inxaxheba kwaye ugcine amaxwebhu akho, nceda wenze i-akhawunti.",
    "SUCCESS": "Unokuthi ngoku uthathe inxaxheba kulengxoxo.",
    "TOOLTIP": "Le ngxoxo lweengxoxo lukhuselekile kwaye lufuna iinkcukacha ezithile ukuze uthathe inxaxheba.",
    "VALIDATED_INLINE_DESCRIPTION": "Siye sivumile isazisi sakho njengo <b>{fullName}</b>.",
    "VERIFIED_EMAIL": {
      "TITLE": "Ukuqinisekiswa kwe-akhawunti"
    }
  },
  "SECURITY": {
    "DISPLAY_SECURED_STRATEGY_QUESTIONS": "Bonisa imibuzo yokhuseleko",
    "FORM_BUILDER": {
      "DESCRIPTION": "Imibuzo yokhuseleko zizixhobo zolawulo lokufikelela.<br></br> Zivumela ukujonga ukuba abathathi-nxaxheba bayazifezekisa iimeko ezithile ngaphambi kokuba banikele, bavote, bacebise okanye baphendule kuphando (umzekelo: ikhowudi yokufikelela, ID kazwelonke, umhlali welizwe, njl.).",
      "TITLE": "Imibuzo yokhuseleko"
    },
    "OPTION_1": {
      "DESCRIPTION": "Akukho kubhaliswa okudingekayo ukuze uthathe inxaxheba.",
      "TITLE": "Wonke umntu"
    },
    "OPTION_2": {
      "DESCRIPTION": "Abasebenzisi kufuneka babhalise ukuze bathathe inxaxheba",
      "TITLE": "Ababhalisiwe"
    },
    "OPTION_3": {
      "DESCRIPTION": "Abasebenzisi kufuneka baqinisekise iakhawunti yabo ukuze bathathe inxaxheba.",
      "TITLE": "Abasebenzisi abaQinisekisiweyo"
    },
    "OPTION_4": {
      "DESCRIPTION": "Idiphozithi ivaliwe kubasebenzisi",
      "TITLE": "Abaphathi"
    },
    "WHO_CAN_COMMENT": "Ubani onokuphawula?",
    "WHO_CAN_RESPOND_SURVEY": "Ngubani onokuphendula uphando?",
    "WHO_CAN_SUBMIT_CONTRIBUTION": "Ngubani onokufaka igalelo?",
    "WHO_CAN_VOTE": "Ngubani onokuvota?"
  },
  "SETTINGS": {
    "ACCOUNT": {
      "CONNECTION_SETTINGS": "Izicwangciso zokuNxibelelana",
      "DATA_SHARED_WITH_SPACE": "Idatha yam",
      "LANGUAGE": "Ulwimi",
      "PASSWORD": "Iphasiwedi (ubuncinane ziimpawu ezili-12)",
      "VERIFIED": "Qinisekisiwe",
      "VERIFIED_EMAIL": "I-imeyile iqinisekisiwe"
    },
    "COOKIES": {
      "DESCRIPTION": "Izikhukula “ezisebenzayo” ezilandelayo zivumela ukukhutshwa kwezinto ezithile ezikhethekileyo nezikhethwayo ku-Fluicity Engage ukuze kuphuculwe amava akho njengomsebenzisi.",
      "FACEBOOK": {
        "DESCRIPTION": "Ikunika ukuba ungene kwi-spésisi yakho yokuthatha inxaxheba usebenzisa i-akhawunti yakho ye-Facebook.",
        "TITLE": "Facebook Connect"
      },
      "GOOGLE": {
        "DESCRIPTION": "Ikunika ukuba uqhagamshele kwindawo yakho yokuthatha inxaxheba usebenzisa iakhawunti yakho ye-Google.",
        "TITLE": "Ukungena nge-Google"
      },
      "TITLE": "Izinto endizithandayo eziphathelele iikuki",
      "VIMEO": {
        "DESCRIPTION": "Kuvumela ukuba ubukele iividiyo ezigcinwe kuVimeo ngokuthe ngqo ukusuka kwindawo yakho yokuthatha inxaxheba.",
        "TITLE": "Vimeo"
      },
      "YOUTUBE": {
        "DESCRIPTION": "Ikunika ukuba ubukele iividiyo ezigcinwe ku-Youtube ngqo kwindawo yakho yokuthatha inxaxheba.",
        "TITLE": "Youtube"
      }
    },
    "DESTROY_ACCOUNT": {
      "CONFIRM": "Ewe, cima i-akhawunti yam",
      "CTA": "Susa i-akhawunti yam",
      "TITLE": "Uqinisekile na ukuba ufuna ukususa i-akhawunti yakho ye-Fluicity Engage?"
    },
    "EMAIL_SUBSCRIPTION": {
      "UNSUBSCRIBE": {
        "SUCCESS_DESCRIPTION": "Ukuba ufuna ukuphuma okanye uphinde ubhalise kwiindidi ezithile zezaziso, ungaguqula izicwangciso zakho ngezantsi. Ezi zilungiselelo zikwafumaneka nangaliphi na ixesha kwiisethingi zeakhawunti yakho.",
        "SUCCESS_TITLE": "Isicelo sakho sokukhansela ukubhalisela kwenziwe ngempumelelo."
      }
    },
    "JOIN_SPACE": "Joyina {spaceName}",
    "LANGUAGE": {
      "LABEL": "Ulwimi"
    },
    "LEAVE_SPACE": {
      "CONFIRM": "Ewe, shiya isithuba",
      "CTA": "Shiya {spaceName}",
      "DESCRIPTION": "Xa ushiya le ndawo, awuyi kuphinda ufumane izaziso ezinxulumene neengxoxo okanye iindaba kwaye awuyi kukwazi ukwenza igalelo elitsha, ukuphawula, ukuvota, njl.",
      "TITLE": "Uqinisekile ukuba ufuna ukuphuma ku-{spaceName}?"
    },
    "NO_SPACES": "Awukho ndawo oyilandelayo.",
    "PASSWORD": {
      "CONFIRMATION": "Uqinisekiso lwephasiwedi",
      "CREATE": "Dala",
      "CREATE_INPUT": "Dala iphasiwedi entsha",
      "CREATE_MESSAGE": "Awukayilungisi iphasiwedi okwamanje.",
      "CURRENT": "I-password yangoku",
      "DIALOG": {
        "CREATE_TITLE": "Yenza ipassword entsha",
        "SUBTITLE_2": "Nceda ufake igama eligqithisiweyo langoku kunye negama eligqithisiweyo elitsha:",
        "TITLE": "Lungisa iphasiwedi yam.",
        "VALIDATE": "Qinisekisa"
      },
      "ERROR_LOGIN": "Imposiso yokuxhuma.",
      "FORGOT_PASSWORD": "Igama lokungena elingalibalekanga?",
      "NEW": "Iphasiwedi Entsha",
      "PLACEHOLDER": "Iphasiwedi",
      "SHORT_PASSWORD": "Ubude bobude obuncinane bungabi ngaphantsi kwe {length} iimpawu.",
      "SUCCESS": "Igama eligqithisiweyo elitsha ligcinwe ngempumelelo.",
      "UPDATE": "Guqula",
      "WRONG_PASSWORD": "Iphasiwedi kufuneka ibe neempawu eziyi-8 ubuncinane."
    },
    "PERSONAL_DATA": {
      "REQUEST_PERSONAL_DATA": {
        "BUTTON": "Cela une isicelo sokudluliswa kwedatha yami yobuqu.",
        "EMAIL_BODY": "Molo,\n\nNgokuhambelana nePolisi yobumfihlo bedatha ye-Fluicity Engage, ndicela ukufumana ugqithiso lwedatha yam yobuqu epheleleyo egcinwe kwiqonga.\n\nI-imeyile yam yokungena kwi-platform yi: {userEmail}\n\nNdiyacela, enkosi kwangaphambili,\n\n{userName}",
        "EMAIL_SUBJECT": "Isicelo sokuthuthwa kwedatha yami"
      },
      "TITLE": "Ubucala kunye nedatha yomntu siqu"
    },
    "REQUIRED_DIMENSION_INFO": "Ezinye iinkcukacha ziyafuneka ukuze uthathe inxaxheba kule ndawo. Ukuze usebenzise amalungelo akho okuphelisa, vele uphume kule ndawo.",
    "SPACE_SELECTION": "Ukhetho lwendawo",
    "TABS": {
      "INFO": "Ulwazi lwam",
      "MY_SPACE": "Indawo yam",
      "NOTIFICATIONS": "Izigxelo zam",
      "SETTINGS": "Iisetingi zam"
    }
  },
  "SIGN_IN": "Joyina",
  "SIGN_OUT": "Ukuphuma",
  "SIGN_UP": {
    "EMAIL": "I-imeyile",
    "LOCATION_LABEL": "I dolophu ohlala kuyo",
    "LOCATION_PLACEHOLDER": "Umzekelo: Paris",
    "PRIVACY": "Umgaqo-nkqubo Wobumfihlo",
    "TERMS": "IiMeko zokusebenzisa"
  },
  "SORT": {
    "COMMENTED": "Ezona zifakwe izimvo ezininzi",
    "LEAST_EXPENSIVE": "Ezona zixabisa kancinci",
    "POPULAR": "Idumile",
    "RANDOM": "Aléatoire",
    "RECENT": "Iintloko zamva nje",
    "UPVOTED": "Ezona zivotiweyo kakhulu"
  },
  "SPACE": {
    "ABOUT": {
      "STATS": {
        "CONSULTATIONS_COUNT": "{count, plural, =0 {ukubonisana kuqalisiwe} one {ukubonisana kuqalisiwe} other {ukubonisana kuqalisiwe}}",
        "IDEAS_DONE_COUNT": "{count, plural, =0 {igalelo elenziwe} one {igalelo elenziwe} other {igalelo elenziwe}}",
        "PARTICIPATIONS_COUNT": "{count, plural, =0 {ukuthatha inxaxheba} one {ukuthatha inxaxheba} other {ukuthatha inxaxheba}}",
        "SUBSCRIBED_CITIZENS": "{count, plural, =0 {abhalisile} one {abhalisile} other {abhalisile}}"
      },
      "TITLE": "Jikelele"
    },
    "CONSULTATIONS": {
      "EMPTY_STATE": "Uza kufumana apha amaxwebhu, izimemo zokufaka izimvo, iibhajethi zokuthatha inxaxheba, kunye neenkomfa ezipapashwe ngumbutho.",
      "TITLE": "{count, plural, =0 {Akukho nanye utyelelo} one {{count} utyelelo} other {{count} utyelelo}}"
    },
    "CONTRIBUTIONS": {
      "MESSAGING": {
        "EMPTY_STATE": "Uya kufumane imiyalezo yakho kunye neziphene apha.",
        "TITLE": "Imiyalezo yam kunye nezinto ezingaqhelekanga"
      },
      "PROPOSALS": {
        "EMPTY_STATE": "Uzifumane apha iziphumo zakho.",
        "TITLE": "Igalelo lam"
      }
    },
    "FORM": {
      "ADDRESS_LABEL": "Idilesi",
      "ADDRESS_PLACEHOLDER": "Khangela idilesi",
      "ADMINISTRATORS": "Abaphathi",
      "BRAND_LOGO_LABEL": "Ilogo lesithuba sakho",
      "BRAND_LOGO_TOOLTIP": "I logo yesikhala lizakuboniswa phezulu ngakwesobunxele kwephepha lebha yokuhambisa, nakwi-imeyili.",
      "COLOR_LABEL": "Umbala",
      "COLOR_PLACEHOLDER": "Umbala",
      "DECISION_MAKER_FIRST_NAME_LABEL": "Igama lomxhasi",
      "DECISION_MAKER_FIRST_NAME_PLACEHOLDER": "Ngenisa igama lokuqala",
      "DECISION_MAKER_LAST_NAME_LABEL": "Igama lomxhasi-mali",
      "DECISION_MAKER_LAST_NAME_PLACEHOLDER": "Ngenisa igama",
      "DECISION_MAKER_PICTURE_LABEL": "Umfanekiso weprofayili yomxhasi",
      "DECISION_MAKER_ROLE_LABEL": "Indima yesponsor",
      "DECISION_MAKER_ROLE_PLACEHOLDER": "Chaza imigudu yomxhasi kwintlangano yakho.",
      "DESCRIPTION_HELPER": "Ibhulegi meta description ivumela iinjini zokukhangela ukuba zifumane umbono malunga nomxholo wephepha xa kufunwa.\"",
      "DESCRIPTION_LABEL": "Inkcazo yemeta",
      "DESCRIPTION_PLACEHOLDER": "Bhala umbhalo omfutshane onomtsalane nowenza abantu babandakanyeke",
      "EMAIL_LABEL": "I-imeyili",
      "EMAIL_PLACEHOLDER": "email@monsite.com",
      "FACEBOOK_URL_LABEL": "Facebook",
      "FACEBOOK_URL_PLACEHOLDER": "https://www.facebook.com/iphepha-lam",
      "FAVICON_LABEL": "Ilogo lenye ilogo encinane",
      "FAVICON_TOOLTIP": "Iikona yefavicon yile iconi ebonakalayo kumacandelo esiphequluli ukufumanisa lula isayithi lakho.",
      "INSTAGRAM_URL_LABEL": "Instagram",
      "INSTAGRAM_URL_PLACEHOLDER": "https://www.instagram.com/iphepha-lam",
      "LEGAL_NOTICE": {
        "COMPANY_ADDRESS": "Ndawo: 210 avenue Jean Jaurès, 69007 Lyon, France",
        "COMPANY_EMAIL": "I-imeyili : info@flui.city",
        "COMPANY_NAME": "Fluicity",
        "COMPANY_PHONE": "Ifowuni : +33 4 72 51 77 55",
        "HOSTED_BY_AWS": "Site libanjwe ngu: Amazon Web Services (AWS) eParis, eFransi",
        "HOSTING": "Indawo yokuhlala",
        "HOSTING_AND_TECHNICAL_SOLUTION": "Ukusingathwa kunye nesisombululo sobugcisa",
        "HOST_ADDRESS": "Ndawo yewebhusayithi: 38 avenue John F. Kennedy, L-1855 Luxembourg",
        "PLATFORM_HOSTED_BY": "I apologize, let me provide the correct translation:\n\nIqonga liyaqhubekekiswa kwaye liqhutywa ngu-Fluicity Engage, isisombululo esiphuhliswe yinkampani i-Fluicity.",
        "THIRD_PARTY_TRUST": "U-Fluicity Engage isebenza njengomlamli othembekayo ekuqokeleleni nasekusebenziseni idatha, kuhlonishwa i-RGPD."
      },
      "LINKEDIN_URL_LABEL": "LinkedIn",
      "LINKEDIN_URL_PLACEHOLDER": "https://www.linkedin.com/iphepha-lam",
      "LOCALES": "Iilwimi",
      "LOCALES_HELPER": "Khetha iilwimi apho abasebenzisi baya kukwazi ukuhamba kwi-platform yakho.",
      "LOCALES_LABEL": "Iilwimi ezifumanekayo",
      "LOCALE_DEFAULT_HELPER": "Khetha ulwimi olungagqibekanga lweqonga lakho.",
      "LOCALE_DEFAULT_LABEL": "Ulwimi olungagqibekanga",
      "LOGO_PICTURE_LABEL": "Umfanekiso weprofayile yabaphathi",
      "LOGO_PICTURE_TOOLTIP": "Xa benza udliwano-ndlebe, igalelo, umyalezo okanye bephawula kwiqonga, abalawuli baya kuchongwa ngale mifanekiso yeprofayili kunye negama lendawo endaweni yomfanekiso wabo kunye negama.",
      "NAME_HELPER": "Igama lesithuba liya kuboniswa kwiindawo ezininzi: kwigama lamaphepha, kwi-imeyile, endaweni yegama labalawuli, njl.",
      "NAME_LABEL": "Igama lesithuba",
      "NAME_PLACEHOLDER": "Cacisa igama lendawo yakho",
      "PHONE_LABEL": "Ifowuni",
      "PHONE_PLACEHOLDER": "0123456789",
      "PRIMARY_COLOR_LABEL": "Umbala ophambili",
      "PRIMARY_COLOR_PLACEHOLDER": "Umbala ophambili",
      "SECONDARY_COLOR_LABEL": "Umbala wesibini",
      "SECONDARY_COLOR_PLACEHOLDER": "Umbala wesibini",
      "SPACE_DECISION_MAKER": "Umxhasi",
      "SPACE_DECISION_MAKER_TOOLTIP": "Uxhaso ngumntu obalulekileyo kumbutho wakho oza kukhuthaza, aqinisekise, azibandakanye nabasebenzisi bakho.",
      "SPACE_LEGAL_NOTICE": "Izaziso Ezisemthethweni",
      "SPACE_LEGAL_NOTICE_LABEL": "Inkcazelo",
      "SPACE_LEGAL_NOTICE_PLACEHOLDER": "Leli phepha liyavela ezantsi kweqonga lakho, phantsi kwephedi yephepha, kunye nolwazi olugcwaliswe ngaphambili ngu-Fluicity Engage njengomphathi kunye nomhleli wezobugcisa wesisombululo.",
      "SPACE_LEGAL_NOTICE_TOOLTIP_1": "Uxwebhu lwezomthetho lwenza ukuba abasebenzisi bazi ubuwena bomphathi wesiza, umphathi wokusingatha, kunye neemeko zokuhlela iqonga.",
      "SPACE_LEGAL_NOTICE_TOOLTIP_2": "Zizinto ziyimfuneko kuyo yonke indawo yewebhu yombutho okanye kawonke-wonke, kwaye ziqinisa ukucaca kwendlela yakho.",
      "SPACE_PRIVACY_POLICY": "Umgaqo-nkqubo wabucala",
      "SPACE_PRIVACY_POLICY_LABEL": "Inkcazo",
      "SPACE_PRIVACY_POLICY_PLACEHOLDER": "Le ntla leboniswa emazantsi eqonga lakho, phantsi kwephepha, kunye nolwazi lwe-Fluicity Engage.",
      "SPACE_PRIVACY_POLICY_TOOLTIP_1": "Umgaqo-nkqubo wabucala uvumela ukwazisa abathathi-nxaxheba malunga nolawulo lwedatha yabo yobuqu. Ungongeza apha iinkcukacha ezithile eziphathelele umbutho wakho (umz. : ixesha lokugcina elithile, unxibelelwano DPO, ukusebenzisa idatha ngaphakathi,...).",
      "SPACE_PRIVACY_POLICY_TOOLTIP_2": "Lo mbhalo ugqibezela <link>umgaqo-nkqubo wabucala we-Fluicity Engage</link>, ophethe iteknoloji yeqonga, kwaye uqinisekisa ukuhambelana ne-RGPD. Ukongezwa kombhalo wakho kuyazikhethela kuxhomekeke ekusebenziseni kwakho iqonga.",
      "SPACE_TERMS_OF_USE": "Imiqathango Yokusebenzisa",
      "SPACE_TERMS_OF_USE_LABEL": "Inkcazo",
      "SPACE_TERMS_OF_USE_PLACEHOLDER": "Yongeza apha umxholo wemigaqo yakho yesiko yokusetyenziswa",
      "SPACE_TERMS_OF_USE_TOOLTIP_1": "I apologize for the oversight. Here is the translation:\n\nImiqathango yokusetyenziswa ichaza imigaqo yokusebenzisa kakuhle indawo yakho, amalungelo nemisebenzi yabasebenzisi, kwakunye nezibophelelo zakho njengomququzeleli wenkqubo. (umz: imigaqo yokulawula, amalungelo okuthatha inxaxheba, njl).",
      "SPACE_TERMS_OF_USE_TOOLTIP_2": "Esi sibhalo sigqibezela <link>iCGU zeFluicity Engage</link>, njengesikhuthazi esithembekileyo nesipapashi seqonga. Ukwengeza umbhalo wakho kuhlala kukhetho ngokuxhomekeke kwindlela osebenzisa iqonga ngayo.",
      "TOPICS": "Imixholo",
      "TOPICS_DESCRIPTION": "Izihloko zivumela ukuba uhlu lwendaba zakho zibe ngamaqela ukuze zincede abasebenzisi bafumane umxholo ngokweemfuno zabo.",
      "TWITTER_URL_LABEL": "Twitter",
      "TWITTER_URL_PLACEHOLDER": "https://twitter.com/iphepha-lam",
      "UPDATED_SUCCESSFULLY": "Indawo yakho ihlaziyiwe ngempumelelo.",
      "USERS_NOTIFICATIONS_SETTINGS": {
        "EVENTABLE": {
          "LABEL": "Thumela isaziso ngokuzenzekelayo ngexesha lokuqalisa kwengxoxo kunye kuzo zonke izigaba zokuthatha inxaxheba."
        },
        "TITLE": "Izaziso",
        "WEEKLY": {
          "LABEL": "Thumela isishwankathelo seenkcukacha zeveki kubabhalisile (amanqaku amatsha, iziganeko ezitsha kunye nezikhumbuzo zokuthatha inxaxheba kwingxoxo)."
        }
      },
      "WEBSITE_URL_LABEL": "Iwebhusayithi",
      "WEBSITE_URL_PLACEHOLDER": "https://www.monsite.com",
      "YOUR_SPACE": "Indawo yakho"
    },
    "HOME": {
      "AFFILIATES": {
        "AFFILIATED": "IiNdawo ezinxulumene nazo",
        "SEE_MORE": "Bona ({count})"
      },
      "FOOTER": {
        "TITLE": "Masigcine Sisonwabile!"
      },
      "SEE": "Jonga",
      "SPACE_INFO": {
        "CITIZENS_COUNT": "{count, plural, =0 {Akukho babhalisiweyo} one {{count} obhalisiweyo} other {{count} ababhalisiweyo}}",
        "IDEAS_COUNT": "{count, plural, =0 {Akukho zithathi-nxaxheba} one {{count} isithathi-nxaxheba} other {{count} izithathi-nxaxheba}}"
      },
      "SPONSOR": "Le ndawo le ibandakanyeka ku"
    },
    "NEWS": {
      "EMPTY_STATE": "Nantsi indawo onokufumana kuyo amanqaku kunye neziganeko ezipapashwe ngumbutho.",
      "TITLE": "{count, plural, =0 {Akukho zindaba} one {{count} indaba} other {{count} izindaba}}"
    },
    "PRIVACY_POLICY": {
      "ACCESS_FLUICITY_PRIVACY": "Cela la politique de confidentialité de Fluicity Engage"
    },
    "SETTINGS": {
      "ACCESS": {
        "TAB_DATA_COLLECTION": "Ifomu yokubhalisa",
        "TAB_INVITATIONS": "Izimemo"
      },
      "COMMUNICATION": {
        "TAB_NOTIFICATIONS": "Izaziso"
      },
      "GENERAL": {
        "TAB_APPEARANCE": "Inkangeleko",
        "TAB_LANGUAGES": "Iilwimi",
        "TAB_TOPICS": "Imixholo"
      },
      "LEGAL": {
        "TAB_LEGAL_NOTICE": "Izaziso ezisemthethweni",
        "TAB_PRIVACY_POLICY": "Umgaqo-nkqubo Wobumfihlo",
        "TAB_TERMS_OF_USE": "Ithemba Lokusebenzisa"
      },
      "PAGES": {
        "TAB_ABOUT": "Malunga",
        "TAB_FOOTER": "Isondlo somphambili",
        "TAB_HOME": "Ikhaya",
        "TAB_NAVIGATION": "Ibha ye-Navigation"
      }
    },
    "TERMS_OF_USE": {
      "ACCESS_FLUICITY_TERMS": "Cela iintlobo-mathiriyeli zokusebenzisa Fluicity Engage"
    }
  },
  "SPACE_DATA_COLLECTION": {
    "GENERAL_INFO": "Ulwazi Jikelele",
    "PROF_CATEGORY_ID": {
      "LABEL": "Ikhathalogu yezinga lomsebenzi noluntu"
    },
    "SECTION": {
      "HEADER": "Ifomu yokubhalisa",
      "SUBTITLE1": "Itheyibhulethi yokubhalisa sisixhobo esivumela ukuqokelela idatha malunga nabasebenzisi.",
      "SUBTITLE2": "Lungiselela amasimi okuqokelela ngokwemfuno zakho ngelixa ulandela i-RGPD."
    }
  },
  "STATS": {
    "AGE": {
      "BETWEEN_15_AND_29": "15-29",
      "BETWEEN_30_AND_44": "30-44",
      "BETWEEN_45_AND_59": "45-59",
      "BETWEEN_60_AND_74": "60-74",
      "GT_75": ">75",
      "LT_15": "<15",
      "TITLE": "Ubudala"
    },
    "AI": {
      "ACTIONS": "Iziphakamiso zabasebenzisi:",
      "ACTIONS_TOOLTIP": "Lo mfono-sikhumbuzo weenjongo zabasebenzisi uveliswe yi-AI. Injongo yawo kukunceda uqonde igalelo lokuqala elifakwe ngabathathi-nxaxheba. Isekelwe kwigalelo elidibene apha ngezantsi.",
      "ADD_CLUSTER": "Yongeza iqela lomxholo",
      "ADD_SUB_CLUSTER": "Yongeza iqela elincinci",
      "CLUSTER": {
        "SUMMARY": "Inkcazelo yeqela lomxholo",
        "SUMMARY_PLACEHOLDER": "Inkcazelo yeqela leengongoma.",
        "TITLE": "Igama leqela lomxholo",
        "TITLE_PLACEHOLDER": "Igama leqela lomxholo liza kusetyenziswa yi-AI ukudibanisa iigalelo."
      },
      "DELETE": "Cima",
      "DESCRIPTION": "Inkcazelo :",
      "EDIT": "Umhleli",
      "EDIT_CLUSTER": "Lungisa umxholo",
      "EDIT_SUB_CLUSTER": "Hlela iqela elincinci",
      "EXPLAIN_AI": "Sisebenzisa ubuhlakani bokwenziwa ukuhlola ngononophelo iziphakamiso kulesi siphakamiso. Inhloso yethu ukuhlanganisa lezi ziphakamiso ngezigaba ezihlukene ngokufana kwazo, ukuze sikunikeze ukuqonda okungcono kwezindlela, izifiso eziyinhloko kanye neziphakamiso ezivelayo. Ngale ndlela, uzokwazi kangcono ukuqonda iziphakamiso ezivelayo nemibono esezingeni eliphezulu kulesi siphakamiso.",
      "GENERATE": "Qalisa uhlalutyo",
      "IDEAS": "Iminikelo yoqobo:",
      "IN_FAVOR": "Kwenzela",
      "MOVE_IDEA": "Susa",
      "MOVE_IDEA_TITLE": "Guqula iqela lomxholo okanye iqela elingaphantsi.",
      "OPPOSED": "Nxamnye",
      "SUB_CLUSTER": {
        "SUMMARY": "Inkcazelo yeqela eliphantsi",
        "SUMMARY_PLACEHOLDER": "Inkcazelo yeqela elincinci",
        "TITLE": "Igama leqela elincinane",
        "TITLE_PLACEHOLDER": "Igama leqela elincinci le-thematic liza kusetyenziswa yi-AI ukuhlanganisa izabelo."
      },
      "TOAST": "Uhlalutyo lwe-AI luyenzeka ngoku. Oku kungathatha imizuzu embalwa."
    },
    "CITIES": {
      "TITLE": "Indawo yokuhlala"
    },
    "CLUSTERS": "Amaqela Ezihloko",
    "CLUSTERS_TOOLTIP": "Iingqwalasela ezahlukeneyo zabasebenzisi ziqokelelwa yi-AI ngaphakathi kwesinye okanye ngaphezulu kweendidi.",
    "CLUSTER_OTHER": "Enye",
    "COUNTER_WITH_TREND": {
      "TOOLTIP": "Ukusukela kwiintsuku ezisixhenxe ezidlulileyo"
    },
    "COUNT_PROPOSALS": "{count} {count, plural, 0 {iminikelo} one {iminikelo} other {iminikelo}}",
    "DAY": "Usuku",
    "DELIVERABILITY": "Ukufikeleleka kwempahla",
    "IDEAS_STATUSES": {
      "TITLE": "Iimeko yeminikelo"
    },
    "KPIS": {
      "TOTAL_COMMENTS": "{count, plural, 0 {Izimvo} one {Izimvo} other {Izimvo}}",
      "TOTAL_FORM_RESPONSES": "{count, plural, 0 {Impendulo} one {Impendulo} other {Iimpendulo}}",
      "TOTAL_PARTICIPANTS": "{count, plural, 0 {Umthathi} one {Umthathi} other {Abathathi-nxaxheba}}",
      "TOTAL_VOTES_AGAINST": "{count, plural, 0 {Iivoti ezichasene} one {Ivoti elichasene} other {Iivoti ezichasene}}",
      "TOTAL_VOTES_FOR": "{count, plural, 0 {Amanqaku} one {Inqaku} other {Amanqaku}}"
    },
    "MONTH": "Inyanga",
    "NO_DATA": "Akukho datha ekhoyo okwangoku.",
    "PARTICIPANTS": {
      "TITLE": "Inani leenkokheli",
      "TOTAL_PARTICIPANTS": "Abathathi-nxaxheba",
      "TOTAL_TARGETED_USERS": "Abasebenzisi ababhalisiweyo"
    },
    "PARTICIPANTS_PROGRESSION": "Inguqulelo yabathathi-nxaxheba",
    "PARTICIPANTS_WHO_PERFORMED_AN_ACTION": {
      "TITLE": "Izenzo ezenziwa ngababambiqhaza",
      "TOTAL_COMMENTS": "Nika izimvo",
      "TOTAL_IDEAS": "Yenza igalelo",
      "TOTAL_NO_ACTIONS": "Akukho nento eyenziwayo",
      "TOTAL_STUDY_ANSWERS": "Izimpendulo zophando",
      "TOTAL_VOTES": "Vota"
    },
    "PARTICIPATION_PROGRESSION": "Ukuguquka kokuthatha inxaxheba",
    "PERFORMANCE": "Ukusebenza",
    "PROF_CATEGORIES": {
      "TITLE": "Udidi lwezentlalo nezobuchwepheshe"
    },
    "REFERRERS": "Imithombo yeendlela zendlela",
    "SECTIONS": {
      "ACTIVITY": "Umsebenzi",
      "ENGAGEMENT": "Ukuzibandakanya",
      "PARTICIPANTS_PROFILE": "Iphrofayili yabathathi-nxaxheba"
    },
    "SEX": {
      "TITLE": "Isini",
      "TOTAL_": "Ayinacaciswa",
      "TOTAL_FEMALE": "Feminine",
      "TOTAL_MALE": "Homme",
      "TOTAL_UNSPECIFIED": "Akunqunyelwe"
    },
    "SUBSCRIPTIONS": {
      "TITLE": "Iinjongo zokubhalisela",
      "TOTAL_TARGETED_USERS": "Injongo",
      "TOTAL_USERS": "Abasebenzisi ababhalisileyo"
    },
    "SUBSCRIPTION_PROGRESSION": {
      "TITLE": "Ukwandiswa kwabhaliso"
    },
    "TAB_AI": "Uxoxo lwe-AI (ibêta)",
    "TAB_ATTENDEES": "Abathathi-nxaxheba",
    "TAB_CONTENTS": "Umxholo",
    "TAB_DETAILS": "Iinkcukacha",
    "TAB_EMAILS": "I-imeyili kunye nombhali",
    "TAB_LIST": "Uluhlu",
    "TAB_PARTICIPATION": "Ukuthatha inxaxheba",
    "TAB_PRIVATE_NOTES": "Amanqaku angaphakathi",
    "TAB_PROPOSALS": "Igalelo",
    "TAB_RESPONSES": "Iimpendulo",
    "TAB_RESULTS": "Iimiphumo",
    "TAB_SETTINGS": "Izicwangciso",
    "TAB_STATS": "Izibalo",
    "TAB_VOTES": "Amavoti",
    "TARGETED_POPULATION": "Idemografi (umthombo osemthethweni)",
    "TOP_CONSULTATIONS": {
      "COL_TITLE": "Isihloko",
      "COL_TOTAL": "Abathathi-nxaxheba",
      "SUBTITLE": "Iyonke iminikelo, izimvo, ivoti okanye iimpendulo kuphando",
      "TITLE": "Iingxoxo ezidumileyo"
    },
    "TOP_VIEWED_POSTS": {
      "COL_TITLE": "Isihloko",
      "COL_TOTAL": "Iindwendwe",
      "COL_TYPE": "Uhlobo",
      "TITLE": "Izinto ezivakashelwa kakhulu"
    },
    "TOTAL_ANSWERS": "{answersCount} kwezo {totalCount} {totalCount, plural, 0 {abaphendulayo} one {umphenduli} other {abaphenduli}}",
    "TOTAL_BOUNCED": "Rebondi",
    "TOTAL_CLICKED": "Cofaqa",
    "TOTAL_COMMENTS": "Izimvo",
    "TOTAL_COMMUNICATIONS": "Iindaba",
    "TOTAL_CONSULTATIONS": "Iingcebiso",
    "TOTAL_DELIVERED": "Délivré",
    "TOTAL_IDEAS": "Igalelo",
    "TOTAL_OFFLINE_VOTES": "Iivoti ezingekho kwi-intanethi",
    "TOTAL_ONLINE_VOTES": "Iivoti ezikwi-intanethi",
    "TOTAL_OPENED": "Vulekile",
    "TOTAL_PARTICIPANTS": "Abathathi-nxaxheba",
    "TOTAL_REJECTED": "Isono",
    "TOTAL_RESPONDENTS": "Abaphendulayo",
    "TOTAL_SENT": "Thumeliwe",
    "TOTAL_STUDY_ANSWERS": "Iimpendulo zophando",
    "TOTAL_USERS": "Abasebenzisi abhalisiweyo",
    "TOTAL_VOTERS": "Abavoti",
    "TOTAL_VOTES": "Amavoti",
    "UNIQUE_VISITS": "Iindwendwe ezizodwa",
    "USERS_WHO_ANSWERED": "{count} {count, plural, =0 {umphenduli} one {umphenduli} other {abaphenduli}}",
    "USERS_WHO_PERFORMED_AN_ACTION": {
      "TITLE": "Izinto ezenziwe ngabasebenzisi",
      "TOTAL_COMMENTS": "Nika izimvo",
      "TOTAL_IDEAS": "Nika igalelo",
      "TOTAL_NO_ACTIONS": "Akukho nanto eyenziwayo",
      "TOTAL_STUDY_ANSWERS": "Izimpendulo zophando",
      "TOTAL_VOTES": "Vota"
    },
    "WEEK": "Veki",
    "WORD_CLOUD": "Ilifu lamazwi"
  },
  "TEXT_FIELD": {
    "LENGTH": "{ubude}/{ubudeObukhulu}",
    "LENGTH_ERROR": "{length}/{maxLength} - Ugqithile umda weempawu.",
    "LENGTH_ERROR_TEXT": "Usuke umda wokubhala oogqithisileyo."
  },
  "TOGGLE_POSTS_VIEW": {
    "BUTTON_CAROUSEL": "Ikharusela",
    "BUTTON_GROUP": "Tshintsha imo yokubonisa",
    "BUTTON_LIST": "Uluhlu",
    "BUTTON_MAP": "Ikhadi"
  },
  "TOKENS": "{count, plural, =0 {Akukho jetoni} one {{count} jetoni} other {{count} amajetoni}}",
  "TOPIC_FORM": {
    "ADD_TOPIC": "Yongeza umxholo",
    "DESTROY_WARNING_DIALOG": {
      "DESCRIPTION_1": "Enye okanye ezininzi iziqulatho kwiqonga lakho ngoku zihlukaniswe phantsi kwesi sihloko.",
      "DESCRIPTION_2": "Ngokuyiguqula okanye ukuyisusa, uzakutshintsha udidi lwale mifanekiso.",
      "TITLE": "Ngaba uqinisekile?"
    }
  },
  "TRANSLATION": {
    "REVERSE_TRANSLATE": "Bona umbhalo wokuqala",
    "SUCCESS": "Ukuguqulelwa kugqityiwe ngempumelelo.",
    "TRANSLATE": "Guqulela",
    "TRANSLATING": "Uguqulo luyaqhubeka..."
  },
  "UI_SECTION": {
    "FORM": {
      "ABOUT": {
        "SECTION_DESCRIPTION": "Amaqhezu avumela ukwenza ngokwezifiso iphepha lakho ngokugqamisa ulwazi lwemibhalo, imifanekiso kunye nevidiyo.",
        "SECTION_HEADER": "Iibhulokhi"
      },
      "HOME": {
        "SECTION_DESCRIPTION": "Amabhulokhi avumela wena ukwenza iphepha lakho libe ngokwakho ngokugqamisa ulwazi ngendlela yombhalo, imifanekiso, ividiyo kunye nezinto ezibonakalayo.",
        "SECTION_HEADER": "Iibhulokhi"
      },
      "ITEMS": {
        "ANOMALY_FORM": {
          "DESCRIPTION": "Ukubika ingxaki ngasese",
          "TITLE": "Anomalie"
        },
        "CUSTOM_BLOCK": {
          "DESCRIPTION": "Umbhalo, umfanekiso kunye nevidiyo",
          "TITLE": "Ngokwezifiso"
        },
        "DEMAND_FORM": {
          "DESCRIPTION": "Nxibelelana ngasese ngeqonga",
          "TITLE": "Imiyalezo"
        },
        "FEATURED_CONSULTATIONS": {
          "DESCRIPTION": "Consultation ezivelele, eqhubekayo nezizayo",
          "TITLE": "Ukubonisana"
        },
        "FEATURED_NEWS": {
          "DESCRIPTION": "Inqaku kunye nesiganeko",
          "TITLE": "Iindaba"
        },
        "FOLDERS": {
          "DESCRIPTION": "Dossier kunye nesub-dossier",
          "TITLE": "Idokhumenti"
        },
        "KPIS": {
          "DESCRIPTION": "Inani lababhalisile, iminikelo kunye neengcebiso",
          "TITLE": "Ezinye iinkcukacha"
        },
        "LATEST_IDEAS": {
          "DESCRIPTION": "Uxanduva lwabasebenzisi",
          "TITLE": "Igalelo"
        },
        "SPACE_INFO": {
          "TITLE": "Umbhalo ophezulu"
        }
      },
      "LAYER_ADD_MEDIA": "Yongeza imidiya",
      "LAYER_ADD_PICTURE": "Umfanekiso",
      "LAYER_ADD_VIDEO": "Ividiyo",
      "LAYER_ALIGNMENT": {
        "CENTER": {
          "DESCRIPTION": "Izicatshulwa ziye zacandeka ngokwe media",
          "LABEL": "Embendini"
        },
        "LEFT": {
          "DESCRIPTION": "Imibhalo ikwicala lasekhohlo lemidiya.",
          "LABEL": "Ngasekhohlo"
        },
        "RIGHT": {
          "DESCRIPTION": "Imibhalo isekunene kweendaba.",
          "LABEL": "Ekunene"
        },
        "TITLE": "Uboniso"
      },
      "LAYER_COMMUNICATION_TYPE": {
        "ALL": "Zonke Iindaba",
        "ARTICLE": "Inqaku",
        "EVENT": "Umnyhadala",
        "LABEL": "Uhlobo",
        "PINNED": "Ezikwinika"
      },
      "LAYER_CONSULTATION_TYPE": {
        "ALL": "Zonke iingcebiso",
        "ENDED": "I am sorry, I meant to translate that. Here is the correct translation:\n\nIingcebiso ezigqityiweyo",
        "LABEL": "Uhlobo",
        "ONGOING": "Iinguqulelo ziyaqhubeka",
        "PINNED": "Kwizithathu"
      },
      "LAYER_COUNTERS": {
        "CONSULTATIONS_COUNT": "Iqala iingxoxo",
        "CONTRIBUTIONS_COUNT": "Igalelo elifezekiweyo",
        "PARTICIPATIONS_COUNT": "I apologize for the oversight. Here is the translated text:\n\nIzabelo (iminikelo, iimpendulo zophando, iivoti kunye nezimvo ezifakiweyo)",
        "TITLE": "Bonisa inani le:",
        "USERS_AND_PARTICIPATIONS_COUNT": "Ababhaliswe kunye nokuthatha inxaxheba",
        "USERS_COUNT": "Abohlisi"
      },
      "LAYER_CTA_LABEL": "Ibhanti yomlinganiselo",
      "LAYER_CTA_LABEL_PLACEHOLDER": "Oko ofuna ukukubonisa kwiqhosha",
      "LAYER_CTA_URL": "Url yebhathini",
      "LAYER_CTA_URL_PLACEHOLDER": "Ikhonkco kwiphepha okanye uxwebhu",
      "LAYER_DESCRIPTION_LABEL": "Inkcazo",
      "LAYER_DESCRIPTION_PLACEHOLDER": "Nceda, yongeza apha isiqulatho somqolo. Yiba mfutshane kwaye uchaze kakuhle.",
      "LAYER_FILTERING_TYPE": {
        "ALL": "Zonke iifayile",
        "CHILDREN": "Umxholo wefayile",
        "CUSTOM": "Ngokwezifiso",
        "SELECT_FOLDER": "Khetha ifolda",
        "SELECT_FOLDERS": "Khetha iifolda",
        "TYPE_LABEL": "Uhlobo lohluzo"
      },
      "LAYER_PICTURE_LABEL": "Umfanekiso",
      "LAYER_TITLE_LABEL": "Isihloko",
      "LAYER_TITLE_PLACEHOLDER": "Cwangcisa isihloko sebhulokhi",
      "SELECTION_DIALOG": {
        "TITLE": "Yenza ibhlokhi"
      }
    }
  },
  "USERS": {
    "ACTIONS_MENU": {
      "CONTACT_USER": "Qhagamshelana nomsebenzisi",
      "INVITE": "Mema",
      "UNREGISTER": "Khupha ilungu",
      "UPDATE_ROLE": "Chaza indima"
    },
    "EXPORT": "Ukuthumela ngaphandle kwedatha yomsebenzisi",
    "EXPORT_SUCCESS_TOAST": "Ukuthumela ngaphandle kuyenzeka. Uza kufumana i-imeyile nje ukuba ilungile.",
    "INVITATIONS": {
      "CREATE_FORM": {
        "EMAILS_LABEL": "Uluhlu lwe-imeyile olwahlulwa ngeekoma",
        "EMAILS_PLACEHOLDER": "Umzekelo: umsebenzisi1@umbutho.com, umsebenzisi2@umbutho.org",
        "MESSAGE_LABEL": "Umyalezo wesimemo",
        "MESSAGE_PLACEHOLDER": "Ngenisa umyalezo wesimemo ofutshane nowokuphefumla, oza kubangela ukuba iindwendwe zibe nomdla wokuzimasa indawo yakho kunye nokuthatha inxaxheba.",
        "SUCCESS_TOAST": "Abasebenzisi bamemelelwe ngempumelelo.",
        "TITLE": "Memema abasebenzisi",
        "WARNING": "Qinisekisa ukuba ufumene imvume kubasebenzisi phambi kokuba usebenzise i-imeyile yabo ukubamema."
      },
      "DELETE_FORM": {
        "CONTENT": "Uzakube ukumisa isimemo esithunyelwe ku-<b>{email}</b>. Uqinisekile ukuba ufuna ukuqhubeka?",
        "DELETE": "Cima",
        "TITLE": "Cima umememo."
      }
    },
    "UNREGISTER": {
      "DESCRIPTION_1": "Usenokungenisa esenzayo: Lo mbhalo kufuneka uguqulelwe kwi xh, kodwa ngokungahambelani namgangatho, andinakuphendula ngaphandle kweenguqulelo ezithile ezivela kwi-dataset yam yangoku. Ngokukhawuleza, ndicela uxolo kwaye ndiyakuthanda ukuba ndincede ngale ngxaki.",
      "DESCRIPTION_2": "Ukuba isithuba siyimfihlo, umsebenzisi ochaphazelekayo akasayi kuba nakho ukufikelela kwindawo. Kuya kufuneka ummemele kwakhona ukuze urhoxise lo msebenzi.",
      "DESCRIPTION_3": "Ukuba isithuba sikawonke-wonke, umsebenzisi ochaphazelekayo akasayi kukwazi ukuthatha inxaxheba. Kuya kufuneka aphinde abhalise ukuze arhoxise lo msebenzi.",
      "DESCRIPTION_4": "Ngaba uqinisekile ukuba ufuna ukuqhubeka nalo msebenzi?",
      "TITLE": "Khupha umsebenzisi kwirejista"
    }
  },
  "USER_AVATAR": "Umfanekiso womsebenzisi",
  "USER_VOTES_INFO": {
    "MAX_VOTES_ERROR": "Ususukile inani eliphezulu leevoti.",
    "MAX_VOTES_WARNING": "{count, plural, =0 {Aninakunikwezi inkxaso engenye} one {Unokuxhasa <strong># umnikelo</strong> ongaphezulu.} other {Unokuxhasa <strong># iminikelo</strong> engaphezulu.}}",
    "MIN_VOTES_WARNING": "{count, plural, =0 {Nisona isekela elanele lamagalelo} one {Kusele <strong># inkxaso</strong> ukuze uqinisekise ukuthatha kwakho inxaxheba.} other {Kusele <strong># iinkxaso</strong> ukuze uqinisekise ukuthatha kwakho inxaxheba.}}",
    "VALID_PARTICIPATION": "Ukuthatha kwakho inxaxheba kuqinisekisiwe."
  },
  "VIEW_ALL": "Bona konke",
  "VIRUS_SCAN": {
    "CLEAN": "Ukuhlaziywa kwe-antivirus kulungile",
    "INFECTED": "Ifile yosulelekileyo",
    "INFECTED_ATTACHMENTS_ERROR": "Uxwebhu lubonakala lufakwe usulelo. Nceda ulucime ngaphambi kokugcina.",
    "NO_SCAN": "Ukuhlaziywa kwe-antivirus kuyaqhuba"
  },
  "VOTERS": {
    "DUPLICATES": {
      "CARD": {
        "BIRTHDATE": "Umhla wokuzalwa: {birthdate}",
        "DELETE_VOTE": "Cima iivoti",
        "EMPTY": "Ayikho ulwazi",
        "IMPORTED_AT": "Importwe nge-{date}",
        "KEEP_BOTH": "Gcina zombini",
        "PARTICIPATED_AT": "Ukubamba iqhaza ngo-{date}"
      },
      "DESCRIPTION": "Uxolo, andivumelani, andinakho ukuguqulela umxholo wesicatshulwa oyibonelelweyo.",
      "FOUND_DUPLICATES": "Unayo <b>{count, plural, one {{count} umvoti ofunyenwe ephindwe kabini} other {{count} abavoti abafunyenwe bephindwe kabini}}</b>. Igqitywe ukuhlaziywa <b>{timeAgo}</b>",
      "LOADING": "Ukuqinisekiswa kuqhubeka…",
      "NO_DUPLICATES": "Akukho mhlawumbi ufumanekileyo. Uhlaziyo lokugqibela <b>{timeAgo}</b>",
      "PLACEHOLDER": "Nantsi apho uza kufumana khona abavoti abachongwe njengabaphindaphindiweyo.",
      "REFRESH": "Hlaziya",
      "START_CHECK": "Qalisa ukuhlola",
      "TITLE": "Lawula amafutha aphindaphindiweyo"
    }
  },
  "WYSIWYG": {
    "LINK_PROMPT": {
      "ENTER_URL": "Faka i-URL"
    },
    "PLACEHOLDER": "Qala ukutayipha..."
  }
}